var _style, _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFundoDeAcolhimento(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 750 500",
    style: {
      enableBackground: "new 0 0 750 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{fill:#FFF8E6;}\r\n\t.st2{fill:#FF925C;}\r\n\t.st3{fill:none;stroke:#000000;stroke-miterlimit:10;}\r\n\t.st4{fill:#B5BF97;}\r\n\t.st5{fill:#4F5B3E;}\r\n\t.st6{fill:#B2543F;}\r\n\t.st7{fill:none;stroke:#3A272A;stroke-miterlimit:10;}\r\n\t.st8{fill:#394177;}\r\n\t.st9{fill:#3A272A;}\r\n\t.st10{fill:#6B1D2D;}\r\n\t.st11{fill:#914539;}\r\n\t.st12{fill:#DCE7C0;}\r\n\t.st13{fill:#472416;}\r\n\t.st14{fill:#934437;}\r\n\t.st15{fill:none;stroke:#472416;stroke-miterlimit:10;}\r\n\t.st16{fill:none;stroke:#934B32;stroke-miterlimit:10;}\r\n\t.st17{fill:#FFC7B6;}\r\n\t.st18{fill:#5F3122;}\r\n\t.st19{fill:#EF9F4A;}\r\n\t.st20{fill:none;stroke:#000000;stroke-linejoin:round;stroke-miterlimit:10;}\r\n\t.st21{fill:#EA6744;}\r\n\t.st22{fill:#FFD49C;}\r\n\t.st23{fill:#FFE1BD;}\r\n\t.st24{fill:#6D81E2;}\r\n\t.st25{fill:#394E99;}\r\n\t.st26{fill:#34394E;}\r\n\t.st27{fill:#774A4A;}\r\n\t.st28{fill:#F99C8B;}\r\n\t.st29{fill:#FB7E48;}\r\n\t.st30{fill:#FF83A8;}\r\n\t.st31{fill:#E5BDA3;}\r\n\t.st32{fill:#6C1B33;}\r\n\t.st33{fill:#1A1D3F;}\r\n\t.st34{fill:none;stroke:#394177;stroke-miterlimit:10;}\r\n\t.st35{fill:#B4C7EB;}\r\n\t.st36{fill:#E56D42;}\r\n\t.st37{fill:#260915;}\r\n\t.st38{fill:none;stroke:#4F2237;stroke-miterlimit:10;}\r\n\t.st39{fill:#4F2237;}\r\n\t.st40{fill:#1C1E34;}\r\n\t.st41{fill:#5C607A;}\r\n\t.st42{fill:#FADFC5;}\r\n\t.st43{fill:#FFFDEE;}\r\n\t.st44{fill:none;stroke:#AF4E6E;stroke-miterlimit:10;}\r\n\t.st45{fill:#8E4326;}\r\n\t.st46{fill:none;stroke:#8E4326;stroke-miterlimit:10;}\r\n\t.st47{fill:#7F683B;}\r\n\t.st48{fill:#FFD990;}\r\n\t.st49{fill:#FFEFCC;}\r\n\t.st50{fill:#F85D7F;}\r\n\t.st51{fill:#F49082;}\r\n\t.st52{fill:none;stroke:#ED3662;stroke-miterlimit:10;}\r\n\t.st53{fill:none;stroke:#FFB980;stroke-miterlimit:10;}\r\n\t.st54{fill:#EF897B;}\r\n\t.st55{fill:#754532;}\r\n\t.st56{fill:#945560;}\r\n\t.st57{fill:#70414B;}\r\n\t.st58{fill:#DB5717;}\r\n\t.st59{fill:#492938;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 750,
    height: 500
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M657.2,432.5c-0.5-10.8-7.2-18.2-15-24.6c-17.6-14.4-27.3-29.4-38-48.9c-7.1-12.9-21.5-22.9-35.2-27.8 c-23.8-8.6-50,0.2-75.3,2.6c-59.3,5.8-116.3-23.9-175.8-27.9c-23.4-1.6-47.7,0.8-70.2,7.5c-15,4.5-31,11.9-40.5,24.6 c-10.1,13.5-12.5,31.3-21.9,45.3c-17.8,26.6-50.2,26.8-73.3,45.4c-9,7.3-15.7,20.6-10.1,32c5.9,12.1,21.8,16.6,34.3,17.9 c45.9,4.9,91.2-11.3,137.1-16.4c25.6-2.8,51.6-2.2,77,1.9c27.7,4.5,55.9,13,83.3,7c15.5-3.4,29.8-11.3,45.5-13.3 c22-2.7,43.3,6.7,64.7,12.2C577,478.6,659.5,486.5,657.2,432.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M500,187.7c0,0,38.7,7.8,40.4,9.7c1.3,1.5-7.8,1.7-7.8,1.7s18.8,4.7,18.6,6.5c-0.3,2.7-16-1.3-16-1.3 s15.4,4.9,15.2,7c-0.1,2.1-17.4-2-17.4-2s15.7,4.6,14.9,7c-0.6,1.6-16.9-2.6-16.9-2.6s12.7,4,11.9,5.7 c-0.8,1.7-20.3-5.4-42.9-10.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M532.6,199.1c0,0-4.5,1.6-9.1,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M530,212.3c-1.8-1.9-6.2-5.3-8.4-6.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M566.3,380c-0.1,0.4,0.1,8.8,0.1,8.8s-6.2,9-13.4,13.6c-7.2,4.6-15.5,0.8-15.7-2.8 c-0.5-7.6,6.7-10.8,11.7-20.2C552.7,368.7,566.3,380,566.3,380z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M566,386.4c-3.3,5-7.4,9.6-12.2,13.2c-3.6,2.9-8.7,3.9-13.1,2c-1.4-0.6-2.8-1.5-3.5-2.8 c1,1.2,2.3,1.9,3.7,2.3c4.2,1.5,8.9,0.4,12.3-2.4C558,395.3,562.1,390.9,566,386.4L566,386.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M574.8,307.3l-8.6,73.1c0,0-3.4,4.1-7.8,4c-3.2,0-8.1-1.1-9-2.2c-1-1.1-0.5-2.6-0.5-2.6l-0.2-83.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M550.8,400.6c-2-4.7-6.6-6.8-11.3-8C544.4,392.2,550.2,395.3,550.8,400.6L550.8,400.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M553.1,386.6c-1.6-0.4-3.3-0.8-4.7-1.8C550.1,384.5,552.2,385,553.1,386.6L553.1,386.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M550.9,388.7c-1.6-0.6-2.7-0.7-4.2-1.7C548.3,386.5,550.4,387,550.9,388.7L550.9,388.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M566.2,381.7c-3,3.1-4.9,6.7-5.7,11C559.8,388.4,562.3,383.6,566.2,381.7L566.2,381.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M532.9,369.9c-0.1,0.4,0.1,8.5,0.1,8.5s-6,8.7-12.9,13.1s-14.9,0.7-15.1-2.7c-0.4-7.3,6.4-10.4,11.3-19.5 C519.8,358.9,532.9,369.9,532.9,369.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M532.7,376c-3.2,4.9-7.1,9.3-11.8,12.8c-3.5,2.8-8.4,3.8-12.6,1.9c-1.3-0.6-2.7-1.4-3.4-2.7 c0.9,1.1,2.2,1.8,3.6,2.2c4.1,1.4,8.6,0.4,11.9-2.3C525,384.6,529,380.3,532.7,376L532.7,376z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M541.2,299.4l-8.3,70.9c0,0-3.3,3.9-7.5,3.9c-3.1,0-7.8-1.1-8.7-2.2c-0.9-1.1-0.5-2.5-0.5-2.5l-0.2-81.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M518,389.7c-2-4.5-6.3-6.6-10.9-7.8C511.8,381.6,517.5,384.6,518,389.7L518,389.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M520.2,376.2c-1.6-0.4-3.2-0.7-4.5-1.8C517.4,374.1,519.4,374.6,520.2,376.2L520.2,376.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M518.1,378.2c-1.5-0.6-2.6-0.7-4-1.6C515.6,376.1,517.6,376.6,518.1,378.2L518.1,378.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M532.9,371.5c-2.9,3-4.7,6.5-5.5,10.6C526.7,377.9,529.1,373.3,532.9,371.5L532.9,371.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M505.5,246.1l8.2,119.8c0,0,2.2,3.8,7.4,4.9c9.2,1.9,15-1.8,15-1.8l7.7-115.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M533.3,259.7c0,0,3.9,42.1,5.2,53.4c1.2,11.2,6.1,60.2,6.1,60.2s2.5,5.5,9.7,7.2c7.7,1.8,14.1-4.1,14.1-4.1 s5.6-57.7,6.3-60.9c0.7-3.2,5.3-61,5.3-61"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st7",
    x1: 538.9,
    y1: 317.1,
    x2: 533.8,
    y2: 272.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M535.3,273.1c-2.8-1.1-5.5-2.3-8.2-3.5c-0.3-0.1-0.5,0.3-0.2,0.4c2.7,1.3,5.5,2.4,8.3,3.5 C535.4,273.6,535.5,273.2,535.3,273.1L535.3,273.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M520.9,311.6c-1.4-1.9-2.8-3.7-4-5.7c-1.2-2-2.3-4.1-3.3-6.2c-0.1-0.3-0.6-0.1-0.5,0.2 c1.7,4.3,4.3,8.6,7.5,12C520.7,312.1,521.1,311.8,520.9,311.6L520.9,311.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M552,320.4c-0.5-1-1.2-1.9-1.9-2.8c-0.6-0.9-1.2-1.8-1.9-2.7c-1.3-1.8-2.5-3.5-3.8-5.2 c-0.2-0.2-0.5,0.1-0.4,0.3c1.2,1.9,2.5,3.6,3.8,5.4c0.6,0.9,1.3,1.7,1.9,2.6c0.6,0.8,1.2,1.8,2,2.5 C551.9,320.7,552,320.6,552,320.4L552,320.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M572.2,270.1c-0.8-0.1-1.7-0.1-2.6-0.2c-0.9-0.1-1.9-0.2-2.8-0.4c-1.7-0.3-3.4-0.8-5-1.5 c-3.4-1.3-6.4-3.4-9-5.9c-0.3-0.3-0.8,0.2-0.5,0.5c2.6,2.7,5.7,4.7,9.2,6.1c1.7,0.7,3.6,1.2,5.4,1.5c1.7,0.3,3.7,0.6,5.3,0.2 C572.4,270.4,572.4,270.2,572.2,270.1L572.2,270.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M506.5,257.8c2.8,1.6,6.3,1.6,9.3,1.2c3.5-0.5,6.8-1.7,10-3.1c0.3-0.1,0.1-0.6-0.2-0.5 c-3.2,1.1-6.3,2.3-9.6,2.8c-3.2,0.5-6.3,0.2-9.4-0.7C506.4,257.5,506.3,257.7,506.5,257.8L506.5,257.8z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st10",
    d: "M582.5,190.4c2.5,28.2-1.2,59-3.3,86.9c0,0-25.9,5.7-47.4,3.1c-21.4-2.6-27.4-12.9-27.4-12.9 c-2.2-31-4.4-62-6.6-93.1c0.3,2.7-2.1-18.9,21-17.7C541.7,158,582.5,190.4,582.5,190.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M509.8,187c-29.7-7.5-67.8-15-100.8-18.5l-4.7-22.8c16.7-0.2,36.7,0,53.4,1.3c13.8,1.1,22.5,1.7,34.6,3.3 c11.4,1.5,21.9,1.5,33.5,7.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M517.9,282.2l4.5-113.1l6.6-16.3c0,0-13.4-3.2-42.7-3.9c-11.9,10.1-4.3,35.8-4.3,35.8l16.2,6.1l4.1,77.6 C502.3,268.4,505.5,278.7,517.9,282.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 498.2,
    y1: 190.7,
    x2: 497.2,
    y2: 180.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 514.3,
    y1: 280.9,
    x2: 517.3,
    y2: 174.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "522.4,169.1 511,182.2 520.8,150.3 529.5,151.5  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M564.9,122c9.9-2.1,20.6,2.7,27.2,10.1c1.7,2,3.3,4.2,4.4,6.6c0.6,1.3,1.7,4,0.1,5.1c-0.8,0.5-1.9-0.1-2.6-0.6 c-4.9-3.6-8-9.1-13-12.7c-2.9-2.1-6.5-3.4-9.8-4.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M571.7,122.4c4.5,0.9,8.7,3,12.2,6c3.5,3,6,6.9,8.2,10.9c2,3.6,4,7.4,4.5,11.5c0.1,1.1,0,2.5-1,2.9 c-1,0.5-2.1-0.2-2.9-1c-2.8-2.8-4.6-6.8-6.8-10.1c-2.9-4.6-9.4-13.7-13.9-15"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M570.3,125.5c5.2-0.7,12.1,14.2,13.8,17.5c1.7,3.4,2.6,7.2,2.1,10.9c-0.1,1-0.6,2.2-1.6,2.3c-0.4,0-0.7-0.1-1-0.3 c-1.1-0.7-1.7-2-2.2-3.3c-3.2-7.5-6.1-15.1-8.5-22.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M573.5,123.7c3.6,0.7,6.8,2.8,9.5,5.1c2.8,2.3,5.2,5,7.1,8c1.1,1.7,2,3.5,2.8,5.4 c0.1,0.3,0.7,0.1,0.6-0.2c-1.2-3.5-3.2-6.7-5.7-9.5c-2.4-2.7-5.3-5.2-8.5-7c-1.8-1-3.7-1.7-5.8-2.1 C573.3,123.3,573.2,123.6,573.5,123.7L573.5,123.7z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M527.7,150l-0.2,15.5c0,0,4.9,9.8,16.4,11.1c14.4,1.7,18.2-6.9,18.2-6.9l-0.9-15.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M523,152.2C523,152.1,523,152.1,523,152.2c0.1-6.5,3.2-16,6.2-21.7c5.6-10.7,19.3-12,31.1-4.9 c7.2,4.3,9.8,12.7,7,20.5c-2,5.6-5.8,12-10.4,15.9c-4.4,3.7-11.5,5.3-17.1,5.4C530.5,167.3,522.9,162,523,152.2z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st14",
    cx: 545.8,
    cy: 153.1,
    r: 4.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M532.2,144.8c0,2.1-1.7,3.8-3.8,3.8c-2.1,0-3.8-1.7-3.8-3.8c0-2.1,1.7-3.8,3.8-3.8 C530.4,141,532.2,142.7,532.2,144.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M536.6,141.1c-1.5,1.1-4.3,3.7-3.5,6c0.5,1.5,2.2,1.4,3.5,1.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M554.1,144.1c-0.1-1.2-0.5-2.3-1.3-3.3c-0.3-0.4-0.6-0.7-1-1c-0.8-0.6-1.9-0.7-2.9-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M536.3,134.7c-0.1-0.9-0.6-1.8-1.4-2.4c-0.8-0.5-1.8-0.7-2.7-0.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M546.7,146.6c-0.1,0.9,0.6,1.6,1.5,1.7c0.9,0.1,1.6-0.6,1.7-1.5c0.1-0.9-0.6-1.6-1.5-1.7 C547.5,145,546.8,145.7,546.7,146.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M529.6,139.2c-0.1,0.9,0.6,1.6,1.5,1.7c0.9,0.1,1.6-0.6,1.7-1.5c0.1-0.9-0.6-1.6-1.5-1.7 C530.5,137.6,529.7,138.3,529.6,139.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M563.6,149.2c-4.3-1.6-8.6,1.4-12.7,2.4c-5.8,1.4-12,0.8-17.4-1.6c-3.9-1.8-7.1-5.4-8.5-8.9c-2,2.7-3,6.1-3.7,9.3 c-0.8,3.8-1.3,7.8,0.2,11.5c0.8,2.1,2.3,3.9,4,5.3c3.1,2.5,6.9,4.2,10.9,4.6c3.6,0.3,8,0.4,11.4-1.2c5.1-2.4,9.1-6.3,12.9-10.4 c1.7-1.8,2.4-4.5,3.2-6.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M575.7,135.3c-0.4-4.4-2.8-8.4-5.7-11.6c-2.8-3.2-6.1-6.3-10.1-7.8c-0.4-0.2-0.8-0.3-1.3-0.4 c-5.8-1.8-12.3-1.8-18.1,0.1c-2.9,1-5.8,2.6-7.8,5c-2.1,2.4-2.3,5.5-2.6,8.5c2-2.5,3.6-4.4,5.8-5.4c2.4,2.8,6.6,3.8,10,2.4 c1,3.6,5,6.1,8.6,5.3c0.3,4.3,3.6,8.3,7.8,9.3c-1,2.7-2,6-0.4,8.4c0.4,0.7,0.8,1.2,0.6,2c-0.4,1.8-1.5,3-1.2,4.9 c0.5,2.5,2.7,2.2,4.6,1.3c4.5-2.2,7.5-6.5,8.8-11.3C575.8,142.5,576,138.8,575.7,135.3z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M535.7,123.2c8.4-9.5,22.5-6.7,27.7-5.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M546,126c4.4-4.8,16.7-6.2,23.1-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M554.6,131.2c3.6-1.8,10.3-6.4,16.8-6.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M562.4,140.5c3.5-1.6,9.3-8.1,10.1-13.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M564.1,151.5c6.1-3.4,10.2-11.3,9.8-21.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M559.7,152.1c1.8-1.7,5.1-2.9,6.7-0.2c1.6,2.8,0.4,6.6-2.1,8.6c-1.9,1.5-5.6,3-7.7,1.1 c-0.8-0.8-1-1.9-1.3-2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M564.7,155c-2.4,0.6-4.8,1.2-7.2,1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M556.9,162.5c0,0,2,0.8,4.7-0.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M533.7,155.1l8.4,0.3c0,0,0,5.9-4.6,6.1C533.8,161.6,533.7,155.1,533.7,155.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M568.4,121.3c3.6,3.3,6.5,9.2,7.1,14"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M602.7,194.9c0,0-13.7,1.2-12.9,14c0.8,12.8-1.7,18.6,5.9,23.3c7.6,4.7,21.6-16.5,19.1-25.8 C612.3,197.1,602.7,194.9,602.7,194.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M564.3,169.6l-17.6,10.4v109.1c10,1.9,34.1-8.3,34.4-8.9c0.3-0.6,4.5-60.9,4.5-60.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M565.5,213.2c16.7,7.5,26.6,12.8,54.8,36.9l28,0.9c-7.4-14.4-23.8-41.2-37-53c-12.9-9.7-21.9-17.5-52-33.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M564,165.7c0,0,11.1,5.5,17.1,9.5c21,14,30.3,22.8,30.3,22.8s-20.7,9.3-15.6,34.2l-40.4-25.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M551.5,289.4c-0.1-1,0-107.2,0-107.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st4",
    points: "562.1,162.3 546.7,180.1 557.8,192.8 569,168  "
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 585.3,
    y1: 224.8,
    x2: 567.5,
    y2: 214.1
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M428.5,147.8c0,0-38.7-3.8-40.8-2.5c-1.7,1,6.8,3.8,6.8,3.8s-19.1,0.7-19.5,2.5c-0.5,2.7,15.4,1.7,15.4,1.7 s-15.9,1.9-16.5,4c-0.5,2,17,1.4,17,1.4s-16.2,1.6-16.1,4c0.1,1.7,16.7,0.7,16.7,0.7s-13.2,1.9-12.9,3.7 c0.3,1.8,32.9,0.6,55.8,2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M394.5,149.2c0,0,3.8,2.8,8.4,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M393,162.5c2.2-1.3,7.4-3.3,9.8-3.8"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 515.1,
    y1: 132.7,
    x2: 505.3,
    y2: 121.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 511.8,
    y1: 138.9,
    x2: 497.2,
    y2: 128.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 509.5,
    y1: 145.1,
    x2: 493.5,
    y2: 140.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M366.7,118.4c0,0,31.7-4.9,33.5-3.7c1.4,1-5.5,4.1-5.5,4.1s15.7-1.6,16,0.2c0.5,2.7-12.6,3.9-12.6,3.9 s13.1-0.2,13.5,1.8c0.5,2-13.9,3.7-13.9,3.7s13.2-0.6,13.2,1.8c0,1.7-13.7,2.9-13.7,2.9s10.8-0.2,10.6,1.6 c-0.2,1.8-27.8,3.6-46.5,6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M393.7,119.6c0,0-3.1,2.9-6.8,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M395.1,133c-1.8-1.2-6.1-3.1-8.1-3.5"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M414.8,266.8l-2.4,96.3c0,0-19.5,2.6-17.9-2.7L384,278.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M410.3,357.3c-0.5,0.6-1,1.1-1.5,1.6c-0.6,0.5-1.2,0.8-1.9,1.1c-0.3,0.1-0.1,0.6,0.2,0.5c0.8-0.3,1.5-0.7,2.1-1.2 c0.6-0.5,1.1-1.1,1.5-1.8C410.8,357.3,410.4,357.1,410.3,357.3L410.3,357.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M390.4,311.4c1.6,2.5,3.9,4.6,6.6,5.7c0.3,0.1,0.6-0.3,0.3-0.5c-2.5-1.3-4.8-3.2-6.5-5.5 C390.6,310.9,390.3,311.1,390.4,311.4L390.4,311.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M412.7,355.8c0,0.1,0.3,6.1,0.4,6.8c0.3,2.2,0.4,5.4,0.4,5.4s-3.5,13.7-10.5,18.5 c-7.1,4.8-14.2,1.2-14.5-2.3c-0.7-7,2.2-9.3,4.9-20.6c0.2-0.7,0.3-7.8,0.3-7.8C395.2,358.5,403.9,359.6,412.7,355.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M413.1,366.7c-2,7.2-5.4,15.4-12.3,19.2c-3.5,1.7-8.1,1.5-11.2-1c-0.6-0.5-1.1-1.2-1.3-1.9c0.2,0.7,0.8,1.3,1.4,1.7 C401.7,391.6,409.4,375.8,413.1,366.7L413.1,366.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M384.1,277.3l-7.7,83.7c0,0-18.2,4-16.2-0.7l-9.1-76.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M374.9,359.1c-0.5,0.5-1,0.9-1.6,1.3c-0.6,0.4-1.2,0.6-1.8,0.9c-0.3,0.1-0.2,0.6,0.2,0.6c0.7-0.1,1.4-0.5,2-0.9 c0.6-0.4,1.2-0.9,1.6-1.5C375.4,359.1,375.1,358.9,374.9,359.1L374.9,359.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M356.8,310.2c2,2.6,4.8,4.7,8,5.6c0.3,0.1,0.4-0.4,0.1-0.5c-3-1.1-5.8-2.9-7.9-5.4C356.9,309.8,356.6,310,356.8,310.2 L356.8,310.2z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M377,355c0,0.1,0.3,5.7,0.4,6.3c0.3,2,0.4,6,0.4,6s-5.8,9.9-13.9,15.3c-6.5,4.3-12,0.6-12.3-2.6 c-0.6-6.5,3.7-9.9,8.4-18.6c0-2.1-0.5-6.3-0.5-6.3C360.9,357.5,368.9,358.5,377,355z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M377.7,365c-4.1,5.8-8.8,11.3-14.7,15.3c-3.4,2.5-9.2,2.9-11.7-1.1c4.4,5,10.5,1.5,14.4-2.2 C370,373.3,373.8,369.2,377.7,365L377.7,365z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M409.4,218.5l-24.6,1.3c-0.2-1.8-0.4-3.6-0.6-5.2l-33.9,4.4c-5.3,22.9-4.2,41.5-1.4,62.2 c0,0,6.3,9.7,29.2,11.3c29.7,2.1,37.3-9.5,37.3-9.5S423.9,242.7,409.4,218.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M348.3,276.5c0,0,6.9,8.6,29.8,10.1c29.7,2,38.4-9.4,38.4-9.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M413,284.8c0,0,4.2-42.9-7.4-65.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M337.4,173.5c0,0-15.4,5-42.7,4c-29.2-1.1-44.4-3.6-44.4-3.6l4-23.1c37.9,1.3,53.9-1.2,84.3-9.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M423.4,180.8c11.7,6,29.2,11.6,41.4,16.4c13.4,5.2,34.6,15.8,34.6,15.8l-1.4-26.1c0,0-37.9-26.1-69.4-39"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M372.7,137.1c0,0-14.6-1.9-30.3,1.7c-11.5,2.6-19.2,5.3-19.2,5.3l7.3,35.2l10.8-1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M340,168.4c1.9,15.7,3.8,30.6,7.6,46c0,0,0.4,11.5,2.4,14.1c2,2.7,12.7,7.8,29.8,7.5 c17.1-0.3,27.5-5,30.2-6.8c4.3-3,2.5-13.2,2.5-13.2c4.7-15.1,6.4-29.7,9.2-45.2c0,0-14-39.3-40.9-37.4 C354,135.4,340,168.4,340,168.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M395.1,135.3c0,0,21.3,3.1,31.8,8.6c10.5,5.5,15.9,9.1,15.9,9.1l-13.6,34.6l-14.2-4.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 341.3,
    y1: 178.2,
    x2: 340,
    y2: 165.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 419.5,
    y1: 184.8,
    x2: 422.6,
    y2: 171.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M393.9,144.9c5.1-2,10.2-5,12.9-9.8c2.1-3.9,2.4-8.5,2.3-12.9c-0.1-4.2-0.5-8.4-2-12.3 c-1.4-3.4-3.6-6.3-5.8-9.2c-2.3-2.9-4.7-5.8-8-7.4c-2.9-1.4-6.3-1.7-9.5-1.5c-4.9,0.4-9.7,2.2-13.3,5.5c-3,2.7-5,6.4-6.9,10 c-2.2,4.1-4.3,8.4-4.4,13.1c0,2.7,0.7,5.3,1.6,7.9c1.5,4.5,3.4,8.9,6.5,12.5c3.1,3.6,7.5,6.2,12.3,6.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M369.5,138c-1.3,15,2.2,22.1,10.7,27.2c0,0,15.6-5.3,17.4-24.9l1.1-10.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M369.5,138c-2.2,15.6,3.8,23.4,10.7,27.2c0,0,15.6-5.3,17.4-24.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M366.8,139.3c-2.7,19.4,4.7,29.1,13.2,33.8c0,0,19.4-6.6,21.7-30.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.3,130.9l0.2,7.1c0,0,4,8.7,12.2,9c8.2,0.4,14.1-9.6,14.1-9.6l0.6-7.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M403.8,107.1c0.2,7-0.8,19.4-6.1,27.9c-3.2,5.1-9.8,8.9-16.5,8.5c-4.3-0.2-8.6-1.7-11.8-4.7 c-8.3-7.5-5.3-35.6-5.3-35.6s2.4-14,20.8-9.6S403.8,107.1,403.8,107.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M393.8,116.8c-1.5-2.2-4.7-2.8-7-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M380.3,122.8c-0.7,1.2-2.4,4.6,0.2,4.8c0.6,0,1.2-0.2,1.8-0.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M389,122.1c0.2,0.8,1.1,1.3,2,1.1s1.3-1.1,1.1-2c-0.2-0.8-1.1-1.3-2-1.1C389.2,120.3,388.7,121.2,389,122.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M370.6,115.2c1.7-2.1,4.8-2.6,7.1-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.3,121.5c-0.4,0.8-1.4,1-2.2,0.6c-0.8-0.4-1-1.4-0.6-2.2c0.4-0.8,1.4-1,2.2-0.6C375.5,119.7,375.7,120.7,375.3,121.5 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M378.2,130.9l7.7-0.6c0,0,0.6,5.4-3.6,6C378.8,136.9,378.2,130.9,378.2,130.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M396.2,130.2c-0.3,2.1-2.2,3.6-4.3,3.3c-2.1-0.3-3.6-2.2-3.3-4.3c0.3-2.1,2.2-3.6,4.3-3.3 C395,126.2,396.5,128.1,396.2,130.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M375.5,128.8c-0.2,2-2.1,3.5-4.1,3.2c-2-0.2-3.5-2.1-3.2-4.1s2.1-3.5,4.1-3.2 C374.3,125,375.7,126.8,375.5,128.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M395.3,88.8c-0.1-0.1-0.2-0.1-0.3-0.2c-5.9-2.7-14.3-1.9-20.6-0.1c-9.1,2.5-14.5,8.7-19.1,16.7 c-2.5,4.3-3.9,9.5-2.7,14.3c1,4.1,3.5,7.6,3.1,11.9c-0.4,4.2-3.4,8.2-2.6,12.4c0.5,2.5,2.2,4.6,2.8,7.1c0.5,2,0.2,4.1-0.1,6.1 c-0.5,2.9-0.9,6-0.1,8.9c1.2,4.6,5.9,8,10.6,8.1c5.2,0,7.4-7,5.7-10.4c-0.9-1.7-3-4.8-3.4-6.7c-0.6-2.8,0.7-5.5,1.5-8.2 c0.5-1.7,0.7-3.4,0.3-5.1c-0.4-2.1-0.3-2.4-0.7-4.5c-4.9-5.8-4.2-16-4.1-18.6c0.1-3.1,2.6-5.8,4-8.4c1.5-2.6,1.8-6.3,4-8.4 c4.4-4.3,12.7-3.6,16.2,1.4c2.2,3.1,2.6,7.2,3.9,10.8c1.3,3.6,4.3,7.3,8.2,6.8c0,4.4-1.1,8.9-3.3,12.8 c-1.3,2.4-3.1,4.7-3.5,7.4c-0.4,2.6,0.5,5.3,0.3,7.9c-0.2,2.8-1.6,5.4-2.3,8.2c-1.2,4.5-0.5,9.5,2.1,13.3 c2.7,3.8,7.4,6.1,12,5.6c4.6-0.5,8.8-4.1,9.7-8.6c0.7-3.4-0.4-6.9-0.2-10.4c0.2-4.1,2.3-8,5.5-10.4c1.8-1.4,4.1-2.5,5-4.5 c1.2-2.6-0.2-5.7-2.2-7.9c-1.9-2.1-4.4-3.8-5.9-6.3c-2-3.3-2-7.5-2.4-11.4C414.9,105.8,406.6,94.3,395.3,88.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M361.4,100.2c-1.6,2.3-2.9,4.7-3.6,7.4c-0.6,2.6-0.7,5.2-0.3,7.8c0.5,2.9,1.5,5.7,2.1,8.6 c0.3,1.4,0.5,2.9,0.4,4.3c-0.1,1.4-0.4,2.7-0.7,4c-0.7,2.6-1.9,5.1-2.1,7.8c-0.2,2.6,0.9,5.1,1.8,7.5c0.5,1.4,0.9,2.8,1,4.3 c0.1,1.5,0.1,3,0,4.6c-0.1,2-0.4,4.1-0.5,6.1c-0.3,3.8-0.2,9.1,3.9,10.9c0.4,0.2,0.8-0.4,0.4-0.6c-3.5-1.8-3.7-6.1-3.5-9.6 c0.3-4.7,1.3-9.5,0-14.1c-0.7-2.5-2-4.9-2.2-7.5c-0.3-2.6,0.8-5.2,1.6-7.7c0.8-2.5,1.4-5,1.1-7.6c-0.3-2.8-1.2-5.5-1.9-8.2 c-0.8-3.1-1.2-6.1-0.8-9.3C358.7,105.8,359.8,102.8,361.4,100.2C361.6,100.2,361.5,100.2,361.4,100.2L361.4,100.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st23",
    d: "M402,122c0.1-1.9,0.1-3.7-0.2-5.6c-0.3-1.8-0.9-3.6-1.6-5.4c-1.4-3.4-3.6-6.6-6.4-9.1 c-0.3-0.3-0.7,0.2-0.4,0.4c2.6,2.6,4.8,5.6,6.2,9c0.7,1.7,1.2,3.4,1.6,5.1c0.4,1.8,0.6,3.7,0.6,5.5 C401.8,122.1,402,122.1,402,122L402,122z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M397.8,125.8c1.1-2,3.6-4.4,5.9-3c2.4,1.5,2.5,4.8,1,7.4c-1.2,1.9-4,4.7-6.5,4.1c-1-0.2-1.6-1-2.1-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M404.2,125.5c-2,1.5-3.9,2.9-5.9,4.4"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M272,152.6c0,0-43.3-4.8-45.7-3.4c-1.9,1.1,7.6,4.4,7.6,4.4s-21.4-1.4-21.8,0.6c-0.6,2.9,17.2,4,17.2,4 s-17.8,0-18.4,2.3c-0.6,2.2,19,3.8,19,3.8s-18-0.4-18,2.3c0.1,1.9,18.7,2.9,18.7,2.9s-14.7,0-14.4,2c0.3,2,26,2.1,51.5,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M233.9,153.6c0,0,4.2,3.2,9.4,3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M232.2,168.4c2.5-1.4,8.3-3.5,11-4.1"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M210.7,371.2c0.1,0.4-0.1,8.3-0.1,8.3s5.8,8.5,12.6,12.8s14.6,0.7,14.8-2.7c0.4-7.1-6.3-10.2-11-19.1 C223.5,360.4,210.7,371.2,210.7,371.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M210.9,377.2c3.7,4.2,7.6,8.4,12.1,11.7c3.2,2.6,7.6,3.6,11.6,2.2c1.3-0.4,2.6-1.1,3.5-2.2 c-0.7,1.2-2,2-3.3,2.6c-4.1,1.8-8.9,0.9-12.4-1.9C217.8,386.3,214,381.9,210.9,377.2L210.9,377.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M202.7,297l8.1,74.5c0,0,3.2,3.8,7.4,3.8c3,0,7.7-1.1,8.5-2.1c0.9-1.1,0.5-2.4,0.5-2.4l0.2-84.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M225.3,390.6c0.5-5,6.1-8,10.7-7.6C231.5,384.2,227.3,386.2,225.3,390.6L225.3,390.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M223.2,377.4c0.8-1.5,2.8-1.9,4.4-1.7C226.3,376.8,224.7,377,223.2,377.4L223.2,377.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M225.2,379.3c0.2-0.8,0.9-1.3,1.7-1.6c0.7-0.2,1.5-0.3,2.3,0c-0.7,0.5-1.3,0.7-1.9,0.9L225.2,379.3 L225.2,379.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M210.8,372.8c3.7,1.8,6,6.3,5.4,10.4C215.3,379.1,213.6,375.7,210.8,372.8L210.8,372.8z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M242.2,361.6c0.1,0.4-0.1,8-0.1,8s5.6,8.2,12.2,12.4s14.1,0.7,14.3-2.6c0.4-6.9-6.1-9.8-10.7-18.4 C254.6,351.2,242.2,361.6,242.2,361.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M242.4,367.4c3.6,4.1,7.3,8.1,11.7,11.3c3.1,2.5,7.3,3.5,11.2,2.2c1.3-0.4,2.5-1,3.4-2.1 c-0.7,1.2-2,2-3.2,2.6c-4,1.8-8.6,0.9-11.9-1.8C249.1,376.2,245.4,372,242.4,367.4L242.4,367.4z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M234.4,289.5l7.8,72.4c0,0,3.1,3.7,7.1,3.7c2.9,0,7.4-1,8.2-2c0.9-1,0.4-2.3,0.4-2.3l0.2-82"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M256.3,380.3c0.5-4.8,5.9-7.7,10.3-7.3C262.3,374.2,258.2,376.1,256.3,380.3L256.3,380.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M254.2,367.5c0.8-1.5,2.7-1.9,4.3-1.7C257.2,367,255.7,367.2,254.2,367.5L254.2,367.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M256.2,369.4c0.2-0.8,0.9-1.3,1.6-1.6c0.7-0.2,1.5-0.2,2.2,0c-0.6,0.5-1.3,0.7-1.9,0.9L256.2,369.4 L256.2,369.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st25",
    d: "M242.2,363.1c3.6,1.7,5.9,6.1,5.2,10C246.6,369.2,244.9,366,242.2,363.1L242.2,363.1z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M268.1,239.2l-7.8,118.6c0,0-2.1,3.6-7,4.6c-8.7,1.8-14.1-1.7-14.1-1.7l-7.3-114.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st26",
    d: "M241.8,252c0,0-3.7,39.8-4.9,50.4c-1.2,10.6-5.7,62.4-5.7,62.4s-2.3,5.2-9.2,6.8 c-7.2,1.7-13.3-3.9-13.3-3.9s-5.3-60-5.9-62.9s-5-57.6-5-57.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 236.5,
    y1: 305,
    x2: 241.4,
    y2: 264.3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M240.1,265.1c2.7-1,5.3-2.1,7.9-3.3c0.3-0.1,0-0.5-0.2-0.4c-2.6,1.1-5.2,2.3-7.8,3.3 C239.7,264.8,239.8,265.2,240.1,265.1L240.1,265.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M253.9,301.3c1.7-1.8,3.1-3.9,4.4-6c1-1.7,1.9-3.5,2.6-5.3c0.1-0.3-0.4-0.5-0.5-0.2c-0.9,1.8-1.8,3.5-2.7,5.2 c-1.2,2.1-2.7,4.1-4.2,6.1C253.4,301.3,253.7,301.5,253.9,301.3L253.9,301.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M224.4,309.6c0.8-0.8,1.5-1.9,2.2-2.8c0.7-0.9,1.3-1.8,2-2.6c1.1-1.5,2.2-3,3.2-4.5c0.1-0.2-0.2-0.5-0.4-0.3 c-1.1,1.4-2.2,2.9-3.2,4.4c-0.6,0.9-1.2,1.7-1.8,2.6c-0.7,1-1.5,2-2.1,3.1C224.1,309.5,224.3,309.7,224.4,309.6L224.4,309.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M205.1,262.2c1.6,0.4,3.5,0.1,5.1-0.2c1.7-0.3,3.4-0.8,5-1.4c3.3-1.3,6.2-3.2,8.7-5.8c0.3-0.3-0.2-0.8-0.5-0.5 c-2.4,2.4-5.4,4.3-8.5,5.6c-1.6,0.6-3.2,1.1-4.8,1.4c-0.8,0.2-1.7,0.3-2.5,0.3c-0.8,0.1-1.7,0.1-2.5,0.2 C204.9,261.9,204.9,262.2,205.1,262.2L205.1,262.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M267.1,250c-3,0.9-5.9,1.2-9,0.7c-3.1-0.5-6-1.7-8.9-2.7c-0.3-0.1-0.5,0.4-0.2,0.5c3,1.3,6.1,2.4,9.4,2.9 c2.9,0.4,6.3,0.4,8.9-1.1C267.3,250.2,267.2,249.9,267.1,250L267.1,250z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M175.6,175.4c0.1,0.4,11.1,25.2,2.7,28.4c-8.4,3.2-20.8-26.4-20.8-26.4L175.6,175.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M354.4,136.1c0.5-1.5,1-3.1,1.2-4.7c0.3-3.9-1.6-7.1-2.7-10.7c-27.7,2.1-60.7,6-89.5,11l13,33.4 c24-10.6,51.6-23.9,77.6-28L354.4,136.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M213.3,142.9c-15.6,3.9-37.2,14.6-49.6,25.2c-26.3,22.3-33.9,29.5-50.3,64.8l26.7,1.6 c17.4-24,35.2-43.2,54.6-55.2"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M201.4,189.7l-23.1,14.1c0,0,1.9-10.4-4.3-23.5c-6.8-14.3-10.3-12.3-10.3-12.3s24.4-22.1,48-26.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M232.6,136.7c17.7-6.8,33.2-8.1,50-8.9c6.2,8.6,4.3,24.8,4.2,35.8l-17.5,6.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st24",
    d: "M271.5,159.1c-1.9,28.3-3,56.6-3.4,85c0,0-4.6,7.7-24.6,12.4c-20,4.7-45.2-1.4-45.2-1.4 c-4.1-22.7-11.2-49.3-15.4-78.4l36.2-47.7L271.5,159.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M202.3,144.4c4,4.4,9.4,8,15.7,9.9c6.4,1.8,13.7,1.7,19.7-0.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M241.1,150.8c2-1.1,3.2-3.4,3.3-5.7c0.1-2.2-0.7-4.5-1.8-6.4c-1.1-2-2.5-3.8-3.8-5.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M239.6,128.3l0.5,15.1c0,0-5.9,7.5-16.7,6.5c-10.9-1-16-7.3-16-7.3l3.1-15.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M210.5,127.2l-1.4,7.1c1,1.7,2,3.3,3.2,4.6c3.8,4.3,10.6,7,16.1,7.9c3.4,0.5,6.3,0,9.2-1c1.7-1.1,2.5-2.4,2.5-2.4 l-0.5-15.1L210.5,127.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M245,130.7C245,130.7,245,130.7,245,130.7c0.9-6.5-0.8-16.3-2.9-22.4c-3.9-11.4-17.3-14.7-30-9.5 c-7.8,3.2-11.6,11.1-10,19.2c1.1,5.9,3.9,12.8,7.9,17.3c3.8,4.3,10.6,7,16.1,7.9C235.3,144.6,243.6,140.5,245,130.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M233.2,117.8c1.3,1.3,3.7,4.3,2.6,6.4c-0.7,1.4-2.4,1.1-3.7,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M215.4,118.1c0.3-1.2,0.9-2.2,1.7-3.1c0.3-0.3,0.7-0.6,1.1-0.8c0.9-0.4,2-0.4,3-0.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M234.5,111.4c0.2-0.9,0.9-1.7,1.7-2.1s1.9-0.5,2.7-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.4,121.7c-0.1,0.9-0.8,1.5-1.7,1.5c-0.9-0.1-1.5-0.8-1.5-1.7c0.1-0.9,0.8-1.5,1.7-1.5 C221.8,120,222.5,120.8,222.4,121.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.4,116.9c-0.1,0.9-0.8,1.5-1.7,1.5c-0.9-0.1-1.5-0.8-1.5-1.7c0.1-0.9,0.8-1.5,1.7-1.5 C239.8,115.2,240.4,116,240.4,116.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.7,129.9l-9.9-0.2c0,0-0.1,5.3,5.2,5.7C236.5,135.8,236.7,129.9,236.7,129.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st27",
    d: "M229.7,89.5c-10.6-4.5-25-1.5-31.1,8.7c-3.6,6-4.8,14.6-3,21.3c1.7,6.2,6.6,13.6,13.2,15.8l-2.2-8.8 c-0.7-4.2-0.5-9.6,2-13.3c2.1-3.2,6.5-3.5,10-3.8c5.8-0.6,13-1,16.4-6.6c1-1.6,2.8-1.3,4.1,0.3c2.8,3.5,4,8.6,5.1,12.9 C245.8,104.7,239.6,93.6,229.7,89.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M211.9,126.8c-1.5-2-4.7-3.8-6.6-1.2c-2,2.7-1.4,6.7,0.7,9.1c1.6,1.9,5.1,4,7.5,2.3 c0.9-0.6,1.3-1.7,1.7-2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M206.4,128.9c2.3,0.9,4.6,1.9,6.9,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M206.2,124.7c0,0,2.6-1.1,4.9,1.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M208.6,136.9c0,0,4.7,2.5,6.3-1.9"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 186.8,
    y1: 199.7,
    x2: 199.9,
    y2: 192.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 270.9,
    y1: 169.3,
    x2: 271.5,
    y2: 159.1
  })), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 251.3,
    y1: 109.8,
    x2: 262.4,
    y2: 98.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 253.7,
    y1: 116.4,
    x2: 269.4,
    y2: 109.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 255.6,
    y1: 122.8,
    x2: 269.6,
    y2: 120.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M346.2,236.2c0,0-20.6-3.1-22.8-1.9c-1.7,1,6.8,4,6.8,4s-19.4-1.4-19.8,0.4c-0.6,2.7,15.6,3.8,15.6,3.8 s-16.1-0.1-16.7,1.9c-0.5,2,17.2,3.5,17.2,3.5s-16.4-0.5-16.3,2c0,1.7,16.9,2.8,16.9,2.8s-13.4-0.1-13.1,1.7 c0.3,1.8,7.2,1,30.4,3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M330.3,238.4c0,0,3.8,2.9,8.5,3.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M328.6,251.8c2.3-1.2,7.6-3.1,10-3.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M253.3,211c0,0,37.2-0.7,39.1,0.6c1.5,1.1-6.8,3.1-6.8,3.1s18.3,0.4,18.5,2.2c0.3,2.6-15,2.1-15,2.1 s15.2,1.4,15.5,3.3c0.3,2-16.5,1.8-16.5,1.8s15.4,1,15.1,3.3c-0.2,1.6-16.1,1.1-16.1,1.1s12.6,1.1,12.1,2.8 c-0.4,1.7-32.5,0-54.5,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M285.6,214.8c0,0-3.8,2.4-8.3,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M285.9,227.5c-2-1.4-6.8-3.6-9.1-4.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M223.4,238.3c0.8-0.5,55.6-3.8,55.7-4.8c0.2-0.9-1.1-23.1-1.1-23.1s-10.3-0.4-25.8-0.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M294.6,419.7c0.1,0.4,0.2,8.8,0.2,8.8s6.5,8.8,13.9,13.1c7.4,4.3,15.5,0.2,15.6-3.4 c0.2-7.6-7-10.5-12.4-19.8C307.8,407.8,294.6,419.7,294.6,419.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M295.1,426c4.1,4.3,8.3,8.6,13.3,12c3.5,2.7,8.2,3.6,12.4,1.9c1.4-0.5,2.7-1.3,3.6-2.5 c-0.7,1.3-2.1,2.2-3.4,2.9c-4.3,2.1-9.4,1.2-13.1-1.6C302.8,435.4,298.6,430.9,295.1,426L295.1,426z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M283.9,357l10.8,63c0,0,3.5,3.9,7.9,3.8c3.2-0.1,8.1-1.4,9-2.6c0.9-1.2,0.4-2.6,0.4-2.6l-2.4-73.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M310.8,439.7c0.4-5.3,6.1-8.6,11-8.4C317.1,432.6,312.7,434.9,310.8,439.7L310.8,439.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M308,425.7c0.8-1.6,2.9-2.2,4.6-2C311.3,424.9,309.6,425.3,308,425.7L308,425.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M310.3,427.7c0.5-1.7,2.6-2.3,4.1-1.8C313,426.9,311.8,427.1,310.3,427.7L310.3,427.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M294.7,421.3c4,1.8,6.6,6.5,6.1,10.8C299.8,427.9,297.8,424.4,294.7,421.3L294.7,421.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st31",
    d: "M327.6,408.4c0.1,0.4,0.2,8.5,0.2,8.5s6.3,8.5,13.4,12.7c7.1,4.2,14.9,0.2,15-3.2 c0.2-7.3-6.8-10.2-12-19.1C340.3,396.9,327.6,408.4,327.6,408.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M328,414.5c3.9,4.2,8.1,8.3,12.8,11.5c3.4,2.6,7.9,3.5,11.9,1.9c1.3-0.5,2.6-1.2,3.5-2.4 c-0.7,1.3-2,2.2-3.3,2.8c-4.1,2-9.1,1.2-12.7-1.5C335.4,423.5,331.4,419.2,328,414.5L328,414.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M317.2,347.8l10.4,60.8c0,0,3.4,3.8,7.6,3.6c3.1-0.1,7.8-1.4,8.7-2.5c0.9-1.1,0.4-2.5,0.4-2.5L342,336"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M343.2,427.7c0.4-5.1,5.9-8.3,10.6-8.1C349.3,420.9,345,423.1,343.2,427.7L343.2,427.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M340.5,414.2c0.8-1.6,2.8-2.2,4.4-1.9C343.6,413.4,342.1,413.8,340.5,414.2L340.5,414.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M342.7,416.1c0.4-1.6,2.5-2.2,4-1.7C345.3,415.4,344.2,415.5,342.7,416.1L342.7,416.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M327.7,410c3.8,1.7,6.4,6.2,5.9,10.4C332.6,416.3,330.6,412.9,327.7,410L327.7,410z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M351,293.3l-4.3,110.3c0,0-2.1,3.9-7.3,5.1c-9.2,2.2-15-1.2-15-1.2L313,302.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st34",
    x1: 327.6,
    y1: 408.4,
    x2: 318.7,
    y2: 314.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st33",
    d: "M323.6,307.9c0,0-2.4,42.2-3.3,53.5c-0.8,11.3-4.3,50.7-4.3,50.7s-2.3,5.6-9.5,7.5 c-7.6,2.1-14.3-3.6-14.3-3.6s-7.3-47.8-8-50.9c-0.8-3.1-7.4-60.7-7.4-60.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M294.6,417.9c0,0-4.2-46.9-5-53.2c-0.4-3.2-6.6-60.3-6.6-60.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st34",
    x1: 320.1,
    y1: 365.5,
    x2: 323.6,
    y2: 321.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M322.3,321.8c2.8-1.2,5.6-2.4,8.2-3.8c0.3-0.1,0-0.5-0.2-0.4c-2.7,1.3-5.4,2.6-8.1,3.8 C321.9,321.5,322.1,321.9,322.3,321.8L322.3,321.8z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M291.5,410.2c3.1,1.9,7.2,4,10.9,4.1c6.1,0.1,11.1-4.2,14.3-9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M338.3,359.6c3-3.5,5.5-7.8,7-12.2c0.1-0.3-0.4-0.5-0.5-0.2c-0.9,2.1-2,4.2-3.1,6.3c-1.1,2-2.5,4-3.8,5.9 C337.7,359.6,338.1,359.8,338.3,359.6L338.3,359.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M307.4,369.4c0.7-0.8,1.3-1.8,1.9-2.6c0.6-0.9,1.2-1.8,1.8-2.6c1.2-1.8,2.5-3.6,3.6-5.5c0.2-0.3-0.2-0.5-0.4-0.3 c-1.3,1.7-2.5,3.6-3.7,5.4c-0.6,0.9-1.2,1.8-1.7,2.7c-0.6,0.9-1.3,1.8-1.7,2.8C307.1,369.4,307.3,369.6,307.4,369.4 L307.4,369.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st34",
    d: "M324,404.2c0,0,8.3,2.8,13.7,1.6c5.4-1.1,9.2-6,9.2-6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M285.2,320c1.7,0.3,3.6-0.1,5.3-0.4c1.8-0.4,3.6-0.9,5.3-1.7c3.4-1.5,6.5-3.6,9-6.4 c0.3-0.3-0.2-0.8-0.5-0.5c-2.5,2.6-5.4,4.7-8.7,6.2c-1.6,0.7-3.4,1.3-5.1,1.7c-0.9,0.2-1.8,0.4-2.7,0.5 c-0.9,0.1-1.8,0.1-2.6,0.3C285,319.8,285,320,285.2,320L285.2,320z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M350.3,304.8c-3,1.1-6.1,1.5-9.3,1.1c-3.4-0.4-6.5-1.6-9.8-2.5c-0.3-0.1-0.5,0.4-0.1,0.5 c3.2,1.3,6.6,2.3,10,2.7c3.1,0.4,6.6,0.2,9.3-1.5C350.6,305,350.5,304.8,350.3,304.8L350.3,304.8z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M218.5,244.9c0,0-39.5-0.8-41.5,0.6c-1.6,1.1,7.2,3.3,7.2,3.3s-19.4,0.4-19.6,2.3 c-0.3,2.7,15.9,2.2,15.9,2.2s-16.1,1.5-16.4,3.5c-0.3,2.1,17.4,1.9,17.4,1.9s-16.3,1.1-16,3.5c0.2,1.7,17.1,1.1,17.1,1.1 s-13.3,1.2-12.9,3c0.4,1.8,34.5,0,57.8,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M184.2,248.9c0,0,4.1,2.5,8.8,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M183.9,262.4c2.1-1.4,7.2-3.9,9.6-4.6"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M413.2,209.8c0,0,39.5-0.8,41.5,0.6c1.6,1.1-7.2,3.3-7.2,3.3s19.4,0.4,19.6,2.3c0.3,2.7-15.9,2.2-15.9,2.2 s16.1,1.5,16.4,3.5c0.3,2.1-17.4,1.9-17.4,1.9s16.3,1.1,16,3.5c-0.2,1.7-17.1,1.1-17.1,1.1s13.3,1.2,12.9,3 c-0.4,1.8-34.5,0-57.8,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M447.5,213.8c0,0-4.1,2.5-8.8,2.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M447.8,227.3c-2.1-1.4-7.2-3.9-9.6-4.6"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M293.2,202c0,0-19.3,1-33.6,9.3c-14.3,8.3-28.6,20.4-32.6,21.9c-4,1.6-35,11.9-35,11.9l1.6,23.3 c0,0,33.2,3.9,52.5-0.7c19.3-4.7,31.6-15.8,31.6-15.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M250.9,233.1c3.7,22,9.6,37.4,12.5,47c2.7,9,5.6,19.5,7.6,21.6c2,2.1,3.7,4.2,3.7,4.2l1.6,6.7 c0,0,20.7,7.2,42.1,2.8c27.2-5.7,32.9-15.6,32.9-15.6l1.1-8.1c0,0,1.4-4.5,1-8.1c-0.4-3.6-6-21.5-5.9-34.7 c0.1-13.2,0.9-29.5,0.9-29.5L332,206c0,0-19.3-12.8-36.5-5.9C278.3,207.1,250.9,233.1,250.9,233.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st35",
    d: "M307.9,199.7c0,0,17.6-5.7,37.6-3.1c20,2.7,53.6,9,60.3,9.3c6.7,0.3,38.2,2.8,38.2,2.8l-4.4,25.3 c0,0-31,1.6-50.2,1c-19.3-0.5-51.2,0-51.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M273.1,210.9c7,9.3,19.7,14.4,31.1,11.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M308.7,221.3c2.9-1,5.4-3.5,6.9-6.6c1.5-3.1,1.9-7,1.2-10.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M258.5,263.5c5.5-2.5,8.8-3.8,13.6-3.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M347.6,234.1c0.1-4.3,1.3-11,2.6-15.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M274.7,305.7c13.9,6.6,35.6,5.9,55.4-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M337,302.5c7.6-3.7,12.1-6.9,15.2-10.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M227.8,234.1c-1.1,4.4-3.5,10.2-4.4,17.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M225.6,236.9c-1.9,3-5.3,8.8-5.7,12.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M302.2,175.9c2,2.4,3.9,4.9,5.5,7.6c1,1.7,1.8,3.6,2.4,5.6c0.6,2,0.9,4.2,1.9,6c1.2,2,3.4,2.3,5.1,0.7 c2.4-2.3,1.3-6.8,0.5-9.6c1.8,1.5,3.7,1.2,3.8-1.7c0.1-5.2-2.8-10.2-6-13.5c-3.4-3.6-10.3-8.8-14.2-11.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M307.9,178.1c0.7-4,4.1-4.3,6.4-2.9c2.2,1.3,2.8,5,2.5,8c-0.3,4.1-4.9,6.3-6.8,3.1"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 313.6,
    y1: 177.7,
    x2: 311.4,
    y2: 184.4
  })), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M310.4,194.9l1.7,14.3c0,0-5.9,10.7-19.5,7.5c-14.9-3.5-16.2-11-16.2-11l2-14"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M311.7,206.4l-1.4-11.5l-27.5-2.4l-1.5,6.9c1.1,1.8,2.1,3.4,3.2,4.3c5.2,4.1,8,6,14.5,6.3 C302.9,210.1,308.4,209.4,311.7,206.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M306.6,163.2c0.3,0.4,9,22.1,7.7,30.6c-1.7,10.8-9.8,14-16.5,14c-6.6-0.1-13.9-1.7-20.1-7.5 c-4.4-4.1-10.3-18.7-8.8-25.6c1.5-6.8,6.7-16.5,15.5-17.5C293.1,156.4,303.1,158.2,306.6,163.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st32",
    d: "M268.3,174.3c-1.7,3.5-3.6,6.9-5.5,10.3c-1.7,3.1-4.3,6.4-3.9,10.2c0.4,3.7,4.1,0.7,5.4-0.9 c-1.9,4.4-1.3,6.8-0.1,8.2c0.9,1.1,2.5,1.3,4,1.1c1.2-0.1,2.3-1.5,2.8-4.9c-0.7,5.5,3.6,7.4,6.5,5.2c1.3-1,1.8-2.5,2.4-3.9 c2.2-5.9,5.3-11.7,7.2-17.8c0.7-2.4,1.7-4.8,2.8-7.1c0.3-0.7,0.7-1.3,1.5-1.4c1.7-0.1,3.4,0.5,5.1,0.8c2,0.4,3.9,1,5.8,1.7 c1.8,0.7,3.4,1.8,5.2,2.4c6.7,2,2.3-3.6,2.3-3.6s3.4,2.3,5.3,2.7c1.6,0.3,3.2-0.3,3.6-2c0.6-2.7-1.4-5.4-3.3-7.1 c-3-2.8-6.8-4.7-10.5-6.3c-3.7-1.7-7.8-2.2-11.4-4.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M283.8,190.9c-0.9-2.5-4.1-4.2-6-3.5c-3.3,1.1-3.9,5.7-2.5,8.7c0.8,1.9,2.6,3.6,4.4,4.6 c1.9,1,4.2,0.4,5.2-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M277.4,190.4c2,1.6,4,3.3,6,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M278.9,200.3c0,0,1.5,1,3.2,0.7c1.6-0.3,2.3-1.2,2.3-1.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M265.9,179.1c0,0,15,9.1,34.4,0.9c11.7-5,12-14,12-14s-6.7-18.3-29.3-13.9 C262.7,156.1,265.9,179.1,265.9,179.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st38",
    d: "M266.7,169.5c0,0,9.4,7.5,25.2,3.9c13.6-3.1,13.3-16.9,13.3-16.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M305.1,160.7c0.5,0.7,1.1,1.2,1.6,1.8c0.6,0.7,1.1,1.4,1.6,2.1c1,1.4,1.9,2.8,2.8,4.3 c0.2,0.3,0.6,0,0.5-0.3c-0.7-1.6-1.7-3.1-2.7-4.5c-0.5-0.7-1-1.3-1.6-1.9c-0.6-0.6-1.1-1.3-1.8-1.8 C305.2,160.2,305,160.5,305.1,160.7L305.1,160.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M301.7,167.3c0.2,0.6,0.6,1.2,0.8,1.9c0.3,0.6,0.5,1.2,0.8,1.9c0.5,1.3,1,2.5,1.4,3.8 c0.1,0.3,0.6,0.2,0.5-0.2c-0.3-1.3-0.8-2.6-1.4-3.9c-0.3-0.6-0.6-1.2-0.9-1.8c-0.3-0.6-0.6-1.3-1-1.8 C302,166.9,301.7,167,301.7,167.3L301.7,167.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M293.5,173.5c0.1,0.5,0.2,0.9,0.4,1.4c0.1,0.5,0.3,0.9,0.4,1.4c0.3,0.9,0.6,1.9,0.9,2.8 c0.1,0.3,0.7,0.2,0.6-0.2c-0.2-1-0.6-1.9-0.9-2.8c-0.2-0.5-0.3-0.9-0.5-1.4c-0.2-0.5-0.3-0.9-0.5-1.4 C293.8,173.1,293.5,173.3,293.5,173.5L293.5,173.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M284,174.6c-0.1,0.5,0,1.1,0,1.6c0,0.5,0.1,1.1,0.2,1.6c0.2,1.1,0.4,2.2,0.8,3.3 c0.1,0.4,0.7,0.2,0.6-0.2c-0.3-1-0.5-2.1-0.7-3.2c-0.1-0.5-0.2-1.1-0.2-1.6c-0.1-0.5-0.1-1.1-0.2-1.6 C284.4,174.4,284.1,174.4,284,174.6L284,174.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M280.5,174.4c-0.3,2.2-0.4,4.6,0.1,6.9c0.1,0.3,0.6,0.2,0.5-0.1c-0.1-1.1-0.2-2.2-0.3-3.4 c0-1.1,0-2.2,0.1-3.4C281.1,174.1,280.6,174.1,280.5,174.4L280.5,174.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st39",
    d: "M272.6,172.2c-0.5,0.1-0.5,0.7-0.6,1.1c-0.1,0.7-0.1,1.4-0.1,2.1c0,1.4,0.1,2.8,0.3,4.1 c0.1,0.4,0.7,0.2,0.7-0.2c-0.2-1.2-0.3-2.4-0.3-3.7c0-0.6,0-1.2,0-1.8c0-0.3,0-0.6,0-0.8c0-0.2,0.1-0.4,0.1-0.6 C272.8,172.3,272.7,172.2,272.6,172.2L272.6,172.2z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M304.2,185.8c0.9,1.5,2.6,4.8,1,6.5c-1,1.1-2.5,0.5-3.6,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M288.5,187.8c0.2-1.1,0.9-2.1,1.7-2.9c0.3-0.3,0.7-0.6,1.1-0.8c0.9-0.4,1.9-0.4,2.8-0.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M305.7,180.6c0.2-0.9,0.9-1.6,1.7-2c0.8-0.4,1.8-0.5,2.6-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.7,189.8c-0.1,0.8-0.8,1.5-1.6,1.4c-0.8-0.1-1.5-0.8-1.4-1.6c0.1-0.8,0.8-1.5,1.6-1.4 C293.2,188.3,293.8,189,293.7,189.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.8,184.5c-0.1,0.8-0.8,1.5-1.6,1.4c-0.8-0.1-1.5-0.8-1.4-1.6c0.1-0.8,0.8-1.5,1.6-1.4 C309.3,182.9,309.9,183.6,309.8,184.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M307,196.1l-6.6-0.1c0,0-0.1,4.4,3.5,4.7C306.8,200.9,307,196.1,307,196.1z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 295,
    cy: 196.8,
    r: 3.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M314.1,191.2c0,1.7-1.4,3.1-3.1,3.1c-1.7,0-3.1-1.4-3.1-3.1c0-1.7,1.4-3.1,3.1-3.1 C312.7,188.1,314.1,189.5,314.1,191.2z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M338.5,190.4c7.4,0.4,14.7,2,21.5,4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M352.7,188c4.1,0.9,8.1,2,12,3.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M166.7,438.5c0.1,0.4,0,7.6,0,7.6s10.7,9.8,18.4,13.5c7.7,3.7,12.1-0.6,11.9-4.2c-0.5-7.6-6.7-9.5-14-19.7 C178.1,425.5,166.7,438.5,166.7,438.5z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M166.7,443.7c4.8,3.6,9.7,7.5,14.8,10.7c3.6,2.1,8,5.3,12.3,3.4c1.3-0.6,2.4-1.8,3.2-3.1 c-0.6,1.4-1.6,2.7-2.9,3.5c-4.4,2.4-9.3-0.7-13.1-3C175.8,451.9,171.1,448,166.7,443.7L166.7,443.7z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M149.6,385.7l18.5,57.3c0,0,9.3,6.7,13.3,8.2c2.3-2.6,5.3-7,9.4-6.4c-5.3-6.3-3.4-4.2-6.4-9l-9.2-73.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M168,437.2c0.6,0.6,1.2,1,2,1.4c0.7,0.3,1.5,0.6,2.3,0.6c0.3,0,0.4-0.5,0.1-0.6c-0.7-0.2-1.5-0.3-2.2-0.6 c-0.7-0.3-1.3-0.7-1.9-1.2C168.1,436.7,167.9,437.1,168,437.2L168,437.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st40",
    d: "M197.4,423.8c0.1,0.3,0.5,7,0.5,7s10.3,8.4,17.6,11.4c7.3,2.9,11.1-1.2,10.7-4.5 c-0.8-6.9-6.6-8.4-13.9-17.3C207.1,411.2,197.4,423.8,197.4,423.8z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st41",
    d: "M197.7,428.5c4.6,3.1,9.4,6.3,14.2,9c3.4,1.8,7.6,4.4,11.5,2.5c1.2-0.6,2.1-1.7,2.7-3 c-2.4,6.9-10,4.2-14.7,1.4C206.5,435.6,201.9,432.3,197.7,428.5L197.7,428.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M186,375l13,52.9c0,0,8.9,5.7,12.6,6.8c1.9-2.5,4.5-6.7,8.3-6.4c-5.2-5.5-3.4-3.7-6.3-7.9l-5.3-68"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M198.6,422.6c0.5,0.5,1.2,0.9,1.9,1.2c0.7,0.3,1.4,0.5,2.2,0.5c0.3,0,0.4-0.5,0.1-0.6c-0.7-0.1-1.4-0.2-2-0.5 c-0.7-0.2-1.3-0.6-1.8-1C198.6,422.1,198.4,422.4,198.6,422.6L198.6,422.6z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st42",
    d: "M144,300.3l-3.8,9.9c0,0-10.3,11.6-4.8,37.2c7.4,33.9,19.7,59.6,19.7,59.6s18.4,6.9,38.4,1.5 c14.5-4,21.4-12.1,21.4-12.1s-0.8-53.9-13.8-96.4c-4.4-10.3-31.4-4.7-31.4-4.7L144,300.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M198.8,319.5c-7.6,10.4-23.7,30.1-23.7,30.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M200.5,336.1c-5.8,4.7-11.1,9.2-16.4,13.4"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st43",
    d: "M192.6,232.4c-6.2-1.4-22.9-0.5-22.9-0.5l-24.7-1.7l-31.7,19.6c0,0,19.3,40.6,22.1,46.7 c2.9,6.1,4.5,17.5,4.5,17.5s30.6,5.4,44.6-0.8c13.9-6.2,16.3-9.4,16.3-9.4s-1.2-15.3-1.1-19.2c2-12,3.6-18.6-1.9-27.2 C194.7,243.8,192.6,232.4,192.6,232.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M140.8,237.9c10,12,22.3,21.9,36.2,29"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M146.6,244c1.1-0.9,2.3-1.8,3.4-2.8c0.2-0.1-0.1-0.4-0.2-0.3c-1.2,0.9-2.3,1.9-3.5,2.8 C146.1,243.9,146.4,244.2,146.6,244L146.6,244z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M151.9,249.1c0.8-1,1.8-1.8,2.7-2.7c0.2-0.2-0.1-0.6-0.4-0.4c-1,0.8-1.8,1.8-2.6,2.9 C151.5,249.1,151.7,249.3,151.9,249.1L151.9,249.1z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M162.3,257.6c0.6-1.5,1.3-2.9,1.9-4.4c0.1-0.3-0.2-0.5-0.4-0.2c-0.8,1.4-1.4,3-2,4.5 C161.8,257.7,162.2,257.8,162.3,257.6L162.3,257.6z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M171.1,263.5c0.3-2,0.6-4,0.7-6c0-0.3-0.4-0.3-0.4,0c-0.2,2-0.4,3.9-0.7,5.9C170.7,263.7,171.1,263.8,171.1,263.5 L171.1,263.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M181.2,261.7c-1.4-2.2-3-4.3-4.7-6.3c-0.2-0.2-0.6,0.1-0.4,0.3c1.6,2.1,3.1,4.1,4.7,6.2 C181,262.2,181.4,261.9,181.2,261.7L181.2,261.7z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M176.3,248c0.7,0.3,1.5,0.7,2.2,1.1c0.4,0.2,0.7,0.4,1.1,0.6c0.3,0.2,0.7,0.4,1.1,0.6c0.2,0.1,0.4-0.2,0.2-0.4 c-0.3-0.3-0.7-0.4-1-0.6c-0.4-0.2-0.8-0.4-1.1-0.6c-0.7-0.4-1.5-0.7-2.3-1C176.3,247.6,176.1,247.9,176.3,248L176.3,248z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M175.2,241.4c0.6,0.1,1.2,0.3,1.8,0.4c0.3,0.1,0.6,0.1,0.9,0.2c0.3,0.1,0.6,0.2,0.9,0.1c0.1-0.1,0.2-0.2,0.1-0.3 c-0.2-0.2-0.6-0.3-0.9-0.3c-0.3-0.1-0.6-0.1-0.9-0.2c-0.6-0.1-1.2-0.2-1.8-0.3C175,240.8,174.9,241.3,175.2,241.4L175.2,241.4z "
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M175.6,230.9c3.6,11,7.2,24.1,4.9,35"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M101.8,262.8c0,0-1.2-44-2.9-46.2c-1.4-1.8-3.3,8.2-3.3,8.2s-1.5-21.6-3.6-21.7c-3-0.2-1.6,17.8-1.6,17.8 s-2.5-17.8-4.8-18.1c-2.3-0.3-1.1,19.5-1.1,19.5s-2.1-18.1-4.8-17.7c-1.9,0.3-0.4,19.1-0.4,19.1s-2-14.8-4-14.2 c-2,0.6,1.8,38.4,3.1,64.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M95.5,224.8c0,0-2.6,4.6-2.5,9.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M80.5,225.2c1.7,2.3,4.7,7.8,5.6,10.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M139.9,233.2c0,0-8.6,0.6-20.9,9.6c-12.3,9-15,12.9-15,12.9l-1.6-14.2l-31.7,2.4c0,0,0.9,35.9,3.2,47.9 c2.7,14.3,18.2,11.2,24.1,9.3c7-2.2,14.5-4.9,14.5-4.9l21.4,55.1c0,0,15.4,9.8,40.6,5.9C156.8,281.9,158.7,256.3,139.9,233.2z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st44",
    x1: 120.1,
    y1: 293.4,
    x2: 139.2,
    y2: 353.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st30",
    d: "M262,209.9c0,0-30.6-0.9-56.5,6.7c-16.6,4.9-29.6,10.3-29.6,10.3c2.2,4.8,10.5,28,15.1,48.1 c5.1,22.9,13.8,71.2,13.8,71.2s7.4-4.4,7.2-5.1c-0.2-0.7-9.1-47.4-8.9-53.2c0.2-4.4,2.2-14.7-1.8-26.6l40.4-38L262,209.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 103.9,
    y1: 255.7,
    x2: 105.9,
    y2: 276.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 112.5,
    y1: 296.1,
    x2: 130.4,
    y2: 289.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M126.8,237.8c0,0,9.1,10.3,12,18.1l13.5-0.2l-8.5,7.3l17.4,30.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M194,288.8c0,0,1-15.5-0.6-32l-8.2-4.1l7.8-1.3c-1.1-6.7-2.7-13.6-5.3-20.2c-6.1-1.9-11.2-2.3-11.2-2.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M134.6,329.8c8.9,1.9,17.2,2.1,23,1.1"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st20",
    x1: 201.3,
    y1: 261.3,
    x2: 197.2,
    y2: 250.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M242.8,222.3c2-2.7,3.9-5.5,5.8-8.3c0.2-0.2-0.2-0.4-0.4-0.2c-2,2.7-3.9,5.5-5.8,8.3 C242.4,222.3,242.7,222.4,242.8,222.3L242.8,222.3z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M243.8,217.2c0.5-1.5,1.1-2.9,1.5-4.4c0.1-0.3-0.3-0.4-0.4-0.1c-0.6,1.4-1.1,2.9-1.6,4.4 C243.3,217.3,243.7,217.5,243.8,217.2L243.8,217.2z"
  }))), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 104.9,
    y1: 266.9,
    x2: 111.2,
    y2: 274.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M112,235.9c4.4-9.5,10.6-16.9,16.4-26.5l17.3,13.9c0,0-14.5,30.4-16.8,31.4c-1.8,0.8-0.6-6.8-0.6-6.8 s-9.7,13.8-11.7,13.3c-1.3-0.4-0.4-2.7,1.1-5.3c-2.1,4.1-3.4,6.2-6,6.2c-0.3,0-0.2-4.6,1.6-8.6c-1.2,3.7-2.1,5.8-4.4,6.1 c-0.7,0.1-0.4-3.7,0.3-6.3c-0.3,1.4-0.7,2.4-1.9,2.4C106,255.5,108.5,243.3,112,235.9z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 128.2,
    y1: 247.8,
    x2: 132.9,
    y2: 243.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 116.5,
    y1: 257.2,
    x2: 123.5,
    y2: 242.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 117.2,
    y1: 240.9,
    x2: 112,
    y2: 256.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 113.4,
    y1: 238.7,
    x2: 108.8,
    y2: 253.6
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M148.4,185.7c-2.9-3.4-7-6.3-11.5-6c-2.2,0.2-4.2,1-6.1,2.1c-11.5,6.3-19.6,18-25.9,28.3l19.9,15l20.1-34.1 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st46",
    d: "M101.8,207.8c7.8-10.3,17.9-25.6,30.4-28.5c4.5-1.1,9.9,0,12.3,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M175.1,230.2l-0.7,9.6c0,0,2.9,5.2,1,17.6c-23.2-10.6-32.5-25.7-32.5-26.1c0-0.4,7.8-15.3,7.4-16"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.3,214.6c0.2,0.3-1.2,3.2-2.7,6.4c1.4,3.6,3.9,6.7,5.7,9.8c2.4,4.1,8.5,7,14.1,7.9c4.2,0.7,5.5,0.4,7,0.4l1.6-9.8 L150.3,214.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M184.5,222.6C184.5,222.6,184.5,222.6,184.5,222.6c0.9-6.5-0.8-16.3-2.9-22.4c-3.9-11.4-17.3-14.7-30-9.5 c-7.8,3.2-11.6,11.1-10,19.2c1.1,5.9,3.9,12.8,7.9,17.3c3.8,4.3,10.6,7,16.1,7.9C174.8,236.5,183.1,232.3,184.5,222.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st45",
    d: "M183.1,205.6c-8.8-4.9-19-7.3-29-6.7c-3.6,8.3-7,16.7-10.1,25.2c-6.2-2.9-10.8-9-12.1-15.7 c-2.4-12,5.5-24.1,16.6-28.3c7.1-2.7,15.3-2.7,22.2,0.6c1.9,0.9,3.7,2.1,5.3,3.5C182,189.3,185,197.9,183.1,205.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M172.7,209.6c1.3,1.3,3.7,4.3,2.6,6.4c-0.7,1.4-2.4,1.1-3.7,0.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M155,209.9c0.3-1.2,0.9-2.2,1.7-3.1c0.3-0.3,0.7-0.6,1.1-0.8c0.9-0.4,2-0.4,3-0.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M174,203.3c0.2-0.9,0.9-1.7,1.7-2.1c0.8-0.4,1.9-0.5,2.7-0.1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M161.9,213.5c-0.1,0.9-0.8,1.5-1.7,1.5c-0.9-0.1-1.5-0.8-1.5-1.7c0.1-0.9,0.8-1.5,1.7-1.5 C161.3,211.9,162,212.6,161.9,213.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.9,208.7c-0.1,0.9-0.8,1.5-1.7,1.5c-0.9-0.1-1.5-0.8-1.5-1.7c0.1-0.9,0.8-1.5,1.7-1.5 C179.3,207.1,180,207.9,179.9,208.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M177.2,221.2l-8.7-0.1c0,0-0.2,5.4,4.5,5.8C177,227.2,177.2,221.2,177.2,221.2z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st29",
    d: "M147.5,217c-1.5-2-5.1-3-7-0.4c-2,2.7-1.4,6.7,0.7,9.1c1.6,1.9,4.9,3,7.2,1.9c1-0.5,1-1.4,1.4-2.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M141.5,219.4c2.3,0.9,4.6,1.9,6.9,2.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144.7,227.7c1,0.3,2.2,0.2,3.1-0.2c1-0.4,1.8-1.3,2-2.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M144.4,182c0,0-16.7,8.6-11.6,29.7"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st21",
    cx: 181.2,
    cy: 216.1,
    r: 2.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M165.7,221.1c0,1.8-1.5,3.3-3.3,3.3c-1.8,0-3.3-1.5-3.3-3.3c0-1.8,1.5-3.3,3.3-3.3 C164.2,217.8,165.7,219.3,165.7,221.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.5,189.9c-4.9,6.7-8.1,14.6-9.2,22.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M70.4,188.8c-2.4,4.5-4.3,9.2-5.6,14.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "st2",
    points: "499.5,219 465.7,219.2 465,242 529.5,246.5  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M491,220.2c0,0-41.9-2.9-44.1-1.4c-1.8,1.1,7.5,3.9,7.5,3.9s-20.6-0.5-21,1.4c-0.5,2.9,16.8,3.2,16.8,3.2 s-17.1,0.7-17.6,2.9c-0.5,2.2,18.4,2.9,18.4,2.9s-17.4,0.3-17.2,2.9c0.1,1.8,18.1,2.1,18.1,2.1s-14.2,0.6-13.8,2.5 c0.4,1.9,36.6,1.8,61.3,2.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M454.3,222.6c0,0,4.2,2.9,9.2,3.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M453.3,237c2.3-1.4,7.9-3.7,10.4-4.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M434.4,397.5c0,0-2.2,1.2-3.4,9.1c-1.2,7.9-5.4,10.4-5.1,16.3c0.3,5.6,3.5,8,7.7,8.9c5.9,1.2,9.5-0.9,11.6-6 c2-5.1,1.2-12.1,2.1-15.6c1-3.5,1.3-5.5,0.3-10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M432.4,392.7l0.8,9.4c0,0,2.4,3.8,6.1,4.4c5.1,0.7,7.6-3.6,7.6-3.6l1.4-15.1"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M426.1,419.9c0.2,1.2,0.4,2.3,0.9,3.4c0.4,1.1,1,2.1,1.8,2.9c0.8,0.8,1.7,1.5,2.7,1.9c1,0.4,2.1,0.7,3.3,0.9 c2.2,0.3,4.6,0,6.6-1.1c2-1.1,3.6-2.9,4.6-5.1c-0.3,1.1-0.9,2.2-1.6,3.2c-0.7,1-1.6,1.8-2.7,2.5c-2.1,1.3-4.7,1.7-7.1,1.4 c-1.2-0.2-2.4-0.5-3.5-1c-1.1-0.5-2.1-1.3-2.9-2.3C426.6,424.8,426,422.3,426.1,419.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M427.3,416.7c1.3-1.5,3.3-2.1,5.2-2.2c1.9-0.1,3.8,0.1,5.7,0.6c1.9,0.6,3.6,1.5,5,2.9c1.4,1.3,2.4,3.1,2.8,5 c-0.7-1.7-1.9-3.2-3.3-4.4c-1.4-1.1-3-2-4.8-2.5c-0.9-0.3-1.8-0.4-2.7-0.6c-0.9-0.1-1.8-0.2-2.7-0.2 C430.7,415.2,428.8,415.5,427.3,416.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M435.7,410.3c1-0.3,1.9-0.3,2.9-0.1c0.9,0.2,1.9,0.5,2.6,1.3c-1,0-1.8-0.2-2.7-0.3C437.5,411,436.6,410.8,435.7,410.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M435.7,408.9c0.9-0.5,2-0.6,3-0.5c1,0.1,2,0.4,2.8,1.2c-1,0-1.9-0.1-2.9-0.2C437.7,409.3,436.7,409.2,435.7,408.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M436.2,406.5c1.1-0.3,2.3-0.2,3.4,0c1.1,0.3,2.2,0.8,2.9,1.7l-3.2-0.7C438.3,407.2,437.3,407,436.2,406.5z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M434.2,404.5c-0.6,0.1-1.2,0.5-1.5,1c-0.6,1,0,2.1,1.1,2.2c1.8,0.3,4-0.4,5.7-1.2 C438.2,405.4,435.9,404.1,434.2,404.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M444.5,405.9c0.5,0.3,0.8,0.7,1,1.3c0.2,1.1-0.5,2-1.4,1.9c-1.6-0.2-3.2-1.3-4.3-2.5 C441,405.8,443.2,405.1,444.5,405.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st6",
    d: "M479.7,400.3c0,0,2.1,1.4,2.6,9.4c0.4,8,4.4,10.8,3.5,16.7c-0.8,5.5-4.2,7.7-8.5,8.1c-6,0.6-9.4-1.7-10.9-7 c-1.6-5.3,0-12.1-0.7-15.7s-0.8-5.6,0.6-10.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M482.1,395.8l-1.6,9.3c0,0-2.7,3.6-6.5,3.8c-5.2,0.2-7.3-4.3-7.3-4.3l-0.2-13.2"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M485.8,423.5c-0.1,2.4-1,4.8-2.7,6.6c-0.9,0.9-1.9,1.6-3.1,2c-1.2,0.4-2.4,0.6-3.6,0.7c-2.4,0.1-5-0.5-7-2.1 c-1-0.8-1.8-1.7-2.4-2.7c-0.6-1.1-1-2.2-1.3-3.4c0.9,2.2,2.2,4.2,4.1,5.5c1.9,1.3,4.2,1.8,6.5,1.7c1.1,0,2.3-0.2,3.3-0.6 c1.1-0.3,2-0.9,2.9-1.7c0.9-0.7,1.5-1.7,2.1-2.7C485.2,425.7,485.6,424.6,485.8,423.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M485,420.1c-1.4-1.3-3.3-1.7-5.1-1.9c-0.9-0.1-1.8-0.1-2.7,0c-0.9,0-1.8,0.1-2.7,0.3c-1.8,0.3-3.5,1.1-5,2 c-1.5,1-2.8,2.4-3.7,4c0.5-1.8,1.7-3.5,3.2-4.7c1.5-1.2,3.4-2,5.3-2.4c1.9-0.4,3.8-0.4,5.8-0.1 C481.9,417.7,483.8,418.5,485,420.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M477.2,413c-0.9,0.4-1.8,0.5-2.7,0.6c-0.9,0.1-1.8,0.1-2.8,0.1c0.7-0.7,1.7-1,2.7-1.1 C475.3,412.5,476.2,412.6,477.2,413z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M477.2,411.6c-1,0.2-2,0.2-2.9,0.2c-0.9,0-1.8,0-2.9-0.1c0.8-0.7,1.9-0.9,2.9-0.9C475.3,410.8,476.4,411,477.2,411.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M477,409.1c-1.1,0.4-2.2,0.5-3.2,0.7l-3.2,0.4c0.8-0.9,2-1.3,3.1-1.4C474.8,408.7,475.9,408.7,477,409.1z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M479.2,407.3c0.6,0.2,1.1,0.6,1.4,1.1c0.5,1-0.2,2-1.3,2.1c-1.9,0.1-4-0.7-5.5-1.7 C475.1,407.9,477.5,406.8,479.2,407.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M468.8,407.7c-0.5,0.2-0.9,0.7-1.1,1.2c-0.3,1.1,0.3,2,1.2,2c1.6,0,3.3-1,4.5-2.1 C472.3,408,470.2,407.1,468.8,407.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M440.2,265.9c-8.6,2.2-14.1,8.2-17.1,15.1c-6.3,14.9-7.1,34.1-5.5,49.8c2.1,20.8,8.1,43.4,11,64.1 c0,0,4.3,3.9,10.1,4.1c5.9,0.2,11.1-3.4,11.1-3.4l8.8-114"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st47",
    d: "M475.3,268.5c8.6,2.3,13.5,6.6,16.3,13.6c6.1,14.9,7.1,35.9,5.3,51.6c-2.4,20.8-8.7,44.6-11.8,65.3 c0,0-4.3,3.9-10.2,4c-5.9,0.1-11.1-3.6-11.1-3.6L453,285.9"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 456.1,
    y1: 319.2,
    x2: 456.4,
    y2: 294.6
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M449.7,294.6c0.1,0.2,0.4,9.8,1.7,11.8c1.7,2.7,4.8,3.6,4.8,3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M442.5,269.8c-8.1,2.2-13.3,8-16.1,14.7c-6,14.4-6.7,33.1-5.3,48.3c1.9,20.2,6,42.9,8.6,63.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M475.4,270.1c7.1,2.4,11.1,6.7,13.5,13.6c5.2,14.8,6.2,35.5,4.9,51c-1.7,20.5-7.2,44-9.6,64.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M424.4,290.5c2.6,1.5,4.8,2.1,7.7,2.8c2.8,0.7,7.7,0.1,10.4-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M490.6,289.6c-4.3,3.4-10.5,4.5-15.7,2.7"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M538.5,245c0,0,38.7,7.9,40.4,9.7c1.3,1.5-7.8,1.7-7.8,1.7s18.8,4.7,18.6,6.5c-0.3,2.7-16-1.3-16-1.3 s15.4,4.9,15.2,7c-0.1,2.1-17.4-2-17.4-2s15.7,4.6,14.9,7c-0.6,1.6-16.9-2.6-16.9-2.6s12.7,4,11.9,5.7 c-0.8,1.7-33.7-7.5-56.4-12.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M571.1,256.4c0,0-4.5,1.6-9.1,0.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M568.5,269.6c-1.8-1.9-6.2-5.3-8.4-6.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M454.3,207.2c0,0-13.9-2-27.3,2.6c-9,3.1-30.9,15.3-35.4,17c-4.6,1.7-44.1,8.1-44.1,8.1s-0.9,18.7,0.5,24.2 c5,0.8,28.3,2.7,50.2-1.5c11.6-2.2,30.8-13.5,30.8-13.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M465.8,208c0,0,14,0.1,26.6,6.6c8.5,4.4,28.2,19.7,32.5,22.1c4.2,2.4,42.3,14.1,42.3,14.1l-3.5,24 c0,0-29-1.1-50-8.6c-11.2-3.9-28.4-18-28.4-18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st48",
    d: "M416.6,236.3c0.6,12.5,5.5,33.7,8.8,45.9c0,0,2.3,12,26.5,13.8c24.2,1.8,33.8-8.2,33.8-8.2 c5.1-11.5,10.5-33,13-45.3v-13.6c0,0-18.8-19.3-41.2-19C435,210.1,416.6,236.3,416.6,236.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M417.8,250.4c0,0-1.2-3.3,0-16.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M495.7,256.1c0,0,3.1-10.4,3.1-16.6"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M438,271c10.3-1.4,20.5-3.1,30.6-5.1c2.9-0.6,5.7-1.1,8.6-1.8c0.4-0.1,0.2-0.6-0.1-0.5c-10.1,2-20.3,4-30.5,5.7 c-2.9,0.5-5.8,0.9-8.7,1.4C437.7,270.7,437.8,271,438,271L438,271z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M440.2,264.8c4.4,0.1,8.8,0.1,13.3,0c4.4-0.2,8.7-0.4,13.1-1c0.3,0,0.2-0.5-0.1-0.5c-4.4,0.3-8.7,0.7-13.1,1 c-4.4,0.2-8.8,0.3-13.1,0.2C440,264.4,440,264.8,440.2,264.8L440.2,264.8z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M450.1,224.2c5.8,3.4,13.3,4.3,19.5,1.7c6.2-2.6,10.7-8.9,10.2-15.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M442.5,207.8c-1.2,4-0.4,8.5,2.2,11.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "359,242 354.7,239.6 354,244.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "381.5,250.7 377.1,253 381,256.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "435.9,212.9 431.5,215.3 435.4,218.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "451.9,282.8 447.5,285.2 451.4,288.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "391.4,233.6 391,238.5 395.8,237.1  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "422.6,237.7 426.2,241.2 428.2,236.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "490.5,240.9 488.5,245.4 493.5,245.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "555.5,254.9 553.4,259.5 558.5,259.8  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "473.5,275.7 477.1,279.2 479.1,274.5  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "522.8,240.8 526.4,244.3 528.4,239.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "488.2,220.6 492.7,222.8 493.1,217.7  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "429.3,262.1 429.6,267.1 434.2,264.9  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "470.2,255.5 470.5,260.5 475.1,258.3  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "454.7,237.7 458.3,241.2 460.3,236.6  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st49",
    points: "529.5,261 533.1,264.5 535.1,259.8  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M465.8,160.1c-5.9-8.5-18.2-6.7-24.9-0.4c-3,2.9-3.9,6.5-5.4,10.3c-0.2,0.4-0.3,0.8-0.6,1.1 c-0.3,0.3-0.7,0.5-1.1,0.6c-2,0.8-4,1.5-5.8,2.7c-1.9,1.2-3.2,2.8-4.2,4.8c-1,2.1-0.5,4.3-0.9,6.6c-0.3,1.9-1.1,3.7-2.5,4.9 c-1.1,0.9-2.4,1.4-3.5,2.1c-1.2,0.7-2.2,1.9-2.2,3.3c0,0.8,0.4,1.6,0.9,2.3c2.7,3.9,7.7,5.3,12.3,5.6c4.6,0.3,9.4-0.3,13.9,0.7 c1.6,0.4,3.2,1,4.9,1.2c1.7,0.2,3.5,0,4.8-1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M441.6,160.6c-3.3,1.2-7.3-0.2-9.3-3.2c-1.9-3-1.5-7.4,0.9-10c2.8-2.9,8-4.6,11.6-2.5 c2.2,1.3,3.3,3.5,3.4,6.1c0.1,2.9-1,5.7-2.2,8.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M460,159.7c7.1-7.5,18.9-3.8,24.7,3.5c2.6,3.3,2.9,7,3.8,11c0.1,0.4,0.2,0.8,0.5,1.2c0.3,0.3,0.6,0.6,1,0.8 c1.8,1.1,3.7,2.1,5.3,3.6c1.7,1.5,2.7,3.2,3.4,5.4c0.7,2.3-0.1,4.3-0.1,6.6c0,1.9,0.5,3.8,1.8,5.2c0.9,1.1,2.1,1.7,3.2,2.7 c1,0.9,1.9,2.3,1.7,3.6c-0.1,0.8-0.6,1.6-1.2,2.2c-3.2,3.5-8.4,4.1-13,3.6c-4.6-0.4-9.2-1.8-13.8-1.4c-1.7,0.1-3.3,0.5-5,0.4 c-1.7,0-3.5-0.5-4.6-1.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M483.9,163.9c3.1,1.7,7.3,1,9.6-1.7c2.3-2.7,2.6-7.1,0.5-10.1c-2.3-3.3-7.2-5.8-11.2-4.3 c-2.4,0.9-3.8,3-4.3,5.5c-0.5,2.8,0.1,5.8,1,8.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M444.9,193.4c-0.7-2.2-2.9-4.9-5.5-4c-2.6,1-3.4,4.3-2.3,7c0.8,2.1,3.3,5.2,5.9,5.1c1-0.1,1.7-0.7,2.4-1.2 "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M439.4,192.4c1.8,1.8,3.5,3.5,5.3,5.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st51",
    d: "M476.6,194.1c1-2,3.6-4.4,6-3.1c2.5,1.4,2.7,4.7,1.2,7.3c-1.1,1.9-4,4.7-6.6,4.1c-1-0.2-1.6-0.9-2.2-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M482.3,194c-2,1.5-4,2.9-6,4.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M446,206.6l0.5,7c0,0,4.8,8.5,14,8.8c9.2,0.3,14-6.8,14-6.8l1.9-10.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M450.1,214.7c8.7,8,20.8,5.6,24.9-4.1c1-2.5,1.4-5,1.4-5l-30-2l-0.1,3.6C447.5,211.2,449,213.6,450.1,214.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st28",
    d: "M441.5,180.6c0,0-1,23.1,7.8,30.4c8.8,7.3,21.1,5.4,26.3-3.1c5.1-8.4,6.2-20.8,5.2-27.7 c-1-6.9-4.8-14-16.3-13.9C453,166.4,442.6,168.6,441.5,180.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M475.2,186.6c-1.4-2.3-4.4-3.3-6.9-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st50",
    d: "M462.4,163.2c-6.4-2.1-13.4,0.6-18.6,4.9c-3.4,2.7-6.4,6.2-7.6,10.5c-0.6,2.1-0.6,4.8,1,6.3 c1.4,1.2,3.4,1.1,5.1,0.4c2.3-0.9,4.1-2.8,5.4-4.9c1.3-2.1,2.2-4.5,3-6.8c-0.2,1-0.3,2.1,0,3.1c0.3,1,1.2,1.9,2.2,1.7 c0.8-0.1,1.4-0.8,1.9-1.4c1.3-1.7,2.4-3.5,3.4-5.4c0.2,1.2,0.5,2.4,1.1,3.5c0.6,1.1,1.6,2,2.8,2.2c1.6,0.3,3.1-0.8,4-2.1 c0.8-1.4,1.1-3.1,1.2-4.7c1.1,2.4,2.4,4.7,3.9,6.8c0.4,0.6,1,1.3,1.7,1.2c0.7,0,1.2-0.6,1.4-1.2c0.2-0.6,0.1-1.3,0.1-2 c1.8,4.4,3.9,9.2,8.2,11c0.5,0.2,1.2,0.4,1.7,0.3c0.7-0.2,1.2-0.9,1.4-1.7c0.2-0.7,0.1-1.5-0.1-2.3c-1.7-8.5-8.6-15.8-16.6-18.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M458.5,160.6c-2.2-0.3-4.4,0.3-6.5,1.1c-3.3,1.3-6.5,3.2-9.3,5.5c-2.4,2-4.5,4.8-5.4,7.9 c-0.3,0.9-0.4,1.8-0.5,2.7c-0.2,1.7-0.1,3.4,0.5,4.9c0.6,1.5,1.9,2.9,3.5,3.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M466.7,160.4c0.7,0,1.5,0.1,2.2,0.2c8.5,1.3,14.9,8.6,17,17c0.5,1.8,0.7,3.7,0.1,5.4 c-0.6,1.7-2.2,3.2-3.9,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M436.2,145.4c-2.3,2-3.1,5.5-2.1,8.3c1.1,2.8,4,4.8,7,4.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M436.9,146.8c-0.3,2.3,0.2,4.6,1.4,6.6c1.2,1.9,3.1,3.3,5.3,3.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M491.3,152c0.9,2.2,0.7,5-0.7,7c-1.4,2-3.8,3.2-6.1,3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M488.6,151c0.1,1.8-0.4,3.7-1.4,5.2c-1,1.5-2.6,2.6-4.3,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M435.5,169.9c0.1,1.7-1.1,3.2-2.2,4.4c-1,1.1-2.1,2.3-3.1,3.4c-1.1,1.2-2.3,2.6-2.7,4.3 c-0.6,2.6,0.9,5.4,0.4,8.1c-0.5,2.4-2.4,4.1-3.5,6.3c-1,2-1.1,4.6-0.4,6.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M433.9,181.9c-0.3,1.8-0.2,3.6,0.2,5.3c0.4,1.6,1.2,3.1,1.1,4.7c-0.1,1.8-1.4,3.3-2.3,4.6 c-0.7,1-1.4,2.1-1.7,3.3c-0.3,1.2-0.3,2.6,0.3,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M488.6,176c0.8,4.5,5.4,7.3,6.1,11.8c0.4,2.9-0.8,6,0.1,8.7c0.5,1.6,1.7,2.8,2.6,4.1 c1.5,2.3,2.1,5.4,0.9,7.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st52",
    d: "M487.6,185.3c0.8,2.2,1.7,4.4,2.5,6.7c0.5,1.4,1.1,2.9,0.8,4.4c-0.2,1.4-1.1,2.6-1.8,3.9 c-1.2,2.3-1.7,5.1-1.3,7.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M439.4,161.6c2.5-3,5.6-5.4,9-6.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st53",
    d: "M477.9,157.4c1.7,0.9,3.5,1.8,5,3.1c1.5,1.3,2.8,2.9,3.5,4.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M460.8,192.9c-0.6,1.3-1.8,5,0.8,4.9c0.6,0,1.2-0.4,1.7-0.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.8,192.4c0.3,0.8,1.3,1.2,2.1,0.9c0.8-0.4,1.2-1.3,0.8-2.2c-0.3-0.8-1.3-1.2-2.1-0.9 C469.8,190.6,469.4,191.6,469.8,192.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M447.4,186.6c1.4-2.3,4.4-3.3,6.9-2.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M452.8,192.4c-0.3,0.8-1.3,1.2-2.1,0.9c-0.8-0.4-1.2-1.3-0.8-2.2c0.3-0.8,1.3-1.2,2.1-0.9 C452.8,190.6,453.1,191.6,452.8,192.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M457.4,200.3l7.6,1.6c0,0-0.9,5.5-5.1,5C456.5,206.4,457.4,200.3,457.4,200.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M476.1,200.3c0,2.2-1.7,4-3.8,4c-2.1,0-3.8-1.8-3.8-4c0-2.2,1.7-4,3.8-4 C474.4,196.3,476.1,198.1,476.1,200.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st54",
    d: "M453.9,200c0,2.1-1.7,3.8-3.7,3.8c-2,0-3.7-1.7-3.7-3.8c0-2.1,1.7-3.8,3.7-3.8 C452.2,196.1,453.9,197.9,453.9,200z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M603.1,454.7c-0.1,0.4-0.2,8.8-0.2,8.8s-6.5,8.8-13.9,13.1c-7.4,4.3-15.5,0.2-15.6-3.4 c-0.2-7.6,7-10.5,12.4-19.8C589.9,442.9,603.1,454.7,603.1,454.7z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M602.6,461c-3.5,4.9-7.7,9.4-12.7,12.8c-3.7,2.8-8.9,3.6-13.1,1.6c-1.3-0.7-2.7-1.6-3.4-2.9 c0.9,1.2,2.3,1.9,3.6,2.5c4.2,1.6,8.9,0.7,12.4-1.9C594.3,469.7,598.6,465.4,602.6,461L602.6,461z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M613.8,392l-10.8,63c0,0-3.5,3.9-7.9,3.8c-3.2-0.1-8.1-1.4-9-2.6c-0.9-1.2-0.4-2.6-0.4-2.6l2.4-73.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M586.9,474.7c-1.9-4.8-6.3-7.1-11-8.4C580.8,466.1,586.5,469.5,586.9,474.7L586.9,474.7z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M589.7,460.8c-1.6-0.5-3.2-0.9-4.6-2C586.8,458.6,588.8,459.2,589.7,460.8L589.7,460.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M587.4,462.8c-1.5-0.7-2.7-0.8-4.1-1.8C584.9,460.5,587,461.1,587.4,462.8L587.4,462.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M603,456.4c-3.1,3-5.1,6.6-6.1,10.8C596.4,462.8,599,458.2,603,456.4L603,456.4z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M560.2,444c-0.1,0.4-0.9,8.4-0.9,8.4s-7,7.9-14.4,11.4c-7.5,3.5-14.9-1.1-14.7-4.6 c0.5-7.3,7.7-9.5,13.6-17.9C548.6,431.4,560.2,444,560.2,444z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M559.3,450c-3.8,4.4-8.2,8.4-13.3,11.2c-3.8,2.4-8.9,2.7-12.8,0.4c-1.2-0.8-2.5-1.7-3-3.1 c0.8,1.2,2,2.1,3.3,2.7c3.9,1.9,8.4,1.4,12.1-0.8C550.5,457.6,555,453.8,559.3,450L559.3,450z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M575.9,384.6l-15.8,59.7c0,0-3.7,3.5-7.9,2.9c-3-0.4-7.6-2.1-8.4-3.2c-0.8-1.2-0.2-2.5-0.2-2.5l8.6-70.8"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M543,461.8c-1.4-4.7-5.5-7.3-9.9-9C537.8,453,543,456.7,543,461.8L543,461.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M546.8,448.6c-1.5-0.6-3-1.1-4.3-2.3C544.2,446.2,546.2,447,546.8,448.6L546.8,448.6z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M544.5,450.4c-1.4-0.8-2.5-1-3.8-2.1C542.2,447.9,544.2,448.7,544.5,450.4L544.5,450.4z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st55",
    d: "M560,445.5c-3.2,2.7-5.4,5.9-6.8,9.8C553,451.2,556,446.9,560,445.5L560,445.5z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M549.2,324l-6.3,113.8c0,0,1.7,2.6,6.7,4.3c8.9,3,15.4,0.2,15.4,0.2l20.5-102.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 561.5,
    y1: 444,
    x2: 578.7,
    y2: 351.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "st56",
    d: "M574.1,343c0,0,2.4,42.2,3.3,53.5c0.8,11.3,4.3,50.7,4.3,50.7s2.3,5.6,9.5,7.5c7.6,2.1,14.3-3.6,14.3-3.6 s7.3-47.8,8-50.9c0.8-3.1,7.4-60.7,7.4-60.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M603.1,452.9c0,0,6.2-47.6,6.9-54c4.7-45.8,6.6-64.6,6.6-64.6"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 576.6,
    y1: 388,
    x2: 574.1,
    y2: 356.1
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M575.6,356.4c-2.7-1.2-5.4-2.5-8.1-3.8c-0.3-0.1-0.5,0.3-0.2,0.4c2.7,1.4,5.4,2.6,8.2,3.8 C575.6,356.9,575.8,356.5,575.6,356.4L575.6,356.4z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M595.3,449.1c-6.1,0.1-11-2.4-14.2-6.6l0.3,6.9c2.2,4.4,7.4,6.3,12.6,6.3c5.4,0,8.6-2.1,11.7-4l0.5-6.8 C603.2,446.9,598.9,449,595.3,449.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M555.6,394.2c-1.1-2-2.3-4-3.2-6.1c-1-2.1-1.8-4.3-2.5-6.6c-0.1-0.3-0.6-0.2-0.5,0.1c1.1,4.5,3.2,9,5.9,12.8 C555.4,394.7,555.8,394.5,555.6,394.2L555.6,394.2z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M590.5,404.3c-0.5-1-1.1-1.8-1.7-2.7c-0.6-0.9-1.2-1.9-1.8-2.8c-1.2-1.8-2.4-3.6-3.7-5.4c-0.2-0.3-0.6,0-0.4,0.3 c1.1,1.9,2.4,3.7,3.6,5.5c0.6,0.9,1.2,1.8,1.8,2.6c0.6,0.9,1.2,1.8,1.9,2.6C590.4,404.6,590.6,404.4,590.5,404.3L590.5,404.3z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st57",
    d: "M550.9,438.1c-5.5-1.6-7.7-5.8-7.7-5.8l-0.7,6.2c0,0,2,4.2,7.5,5.8c5.5,1.6,14.9-0.2,14.9-0.2l0.8-5.7 C565.8,438.3,556.5,439.7,550.9,438.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M614.3,356.5c-1.6-0.3-3.3-0.3-4.9-0.6c-2-0.3-3.9-0.7-5.8-1.3c-1.8-0.5-3.7-1.1-5.4-1.9c-1.4-0.7-2.8-1.5-3.9-2.6 c-1-1-1.4-2.3-0.8-3.7c0.1-0.4-0.5-0.6-0.6-0.3c-1.3,3,1.4,5.3,3.8,6.6c3.6,1.9,7.7,3,11.7,3.6c1.9,0.3,4,0.7,6,0.4 C614.5,356.8,614.5,356.5,614.3,356.5L614.3,356.5z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M548.3,339.6c2.5,1.8,5.8,1.9,8.7,1.8c3.5-0.1,7-0.9,10.3-1.8c0.3-0.1,0.2-0.6-0.1-0.5c-3.3,0.7-6.6,1.5-10,1.6 c-1.4,0.1-2.9,0.1-4.3-0.1c-1.6-0.2-3-0.7-4.4-1.3C548.3,339.2,548.1,339.5,548.3,339.6L548.3,339.6z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M643,274.9c0,0.1-3.3,20.4,4,22.8c5.8,1.9,16.9-30.6,16.9-30.6l-13.7-6.1L643,274.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M546.1,254.9l-21.7-18.5L505,222.8l-5.7-3.9c0,0,9,0.2,22.9,1.7c30.5,3.3,56,9.5,56,9.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M650.5,260.3l9.6,4.5l0.3-30.5l25.4,1.9c0,0,2,36.6,1.7,43.5c-0.4,6.9-1.6,21.7-18.5,18.7 c-8.8-1.5-33.3-10.7-33.3-10.7"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 660,
    y1: 264.7,
    x2: 659.6,
    y2: 278.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M662.2,258.3c0,0-4.5-44.5-3.1-47c1.1-2,4.4,7.8,4.4,7.8s0.7-22,2.8-22.4c3-0.6,2,17.8,2,17.8 s2.1-18.3,4.4-18.9c2.3-0.6,1.8,19.6,1.8,19.6s1.7-18.6,4.5-18.5c1.9,0.1,0.9,19.3,0.9,19.3s2-15.2,4.1-14.9 c2.1,0.3,0.9,37.9,3,64.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M663.6,219.2c0,0,3.2,4.4,3.8,9.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M678.8,217.6c-1.4,2.6-3.7,8.5-4.3,11.3"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M593.7,237.9c0,0-8-7.8-21.3-10.5c-15.7-3.3-25.1-3.7-25.1-3.7s-8.6,8.4-6.6,29.2l16.7,11.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M614.8,242.1c0,0,9.9,2.7,17.3,6.4c12.5,6.3,25.5,15,25.5,15c-9,6.8-15.3,30.9-10.5,34.1l-20.5-6.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st58",
    d: "M556.8,249.2c-0.1,1.1-8.2,76.3-8.2,76.3s1.5,12.2,18.6,20.6c15.5,7.5,26.2,8,37,6.3 c9.5-1.5,16.5-7.2,16.5-7.2l16.8-67L614,243.3l-40.7-9.3"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 633.6,
    y1: 293.8,
    x2: 624,
    y2: 290.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M555.3,263.1c0,0,1.2-9,0-16"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M611.5,257.8c4.7-1.5,9.6-6.4,10.7-13.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M584,233.6c-10.2,10.6-0.4,22.2,11,25.1c4.9,1.2,9.2,1,12.9,0.1"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M649.8,252.1c-4.4-9.5-10.6-16.9-16.4-26.5l-17.3,13.9c0,0,14.5,30.4,16.8,31.4c1.8,0.8,0.6-6.8,0.6-6.8 s9.7,13.8,11.7,13.3c1.3-0.4,0.4-2.7-1.1-5.3c2.1,4.1,3.4,6.2,6,6.2c0.3,0,0.2-4.6-1.6-8.6c1.2,3.7,2.1,5.8,4.4,6.1 c0.7,0.1,0.4-3.7-0.3-6.3c0.3,1.4,0.7,2.4,1.9,2.4C655.7,271.7,653.3,259.6,649.8,252.1z"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 633.5,
    y1: 264,
    x2: 628.8,
    y2: 259.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 645.2,
    y1: 273.4,
    x2: 638.2,
    y2: 259.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 644.5,
    y1: 257.1,
    x2: 649.8,
    y2: 272.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 648.3,
    y1: 254.9,
    x2: 652.9,
    y2: 269.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st59",
    d: "M626.6,220.7c0.6,0.5,3.3,4.6,3.6,5.3c1.8,4.2,5.3,12.4-1.4,13.9c-3.8,0.9-8.2,0.1-11.9-1 c-7.9-2.3-12.4-10.7-14.6-18"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st36",
    d: "M590.6,213.7c-0.3-4.1-3.8-4.7-6.2-3.5c-2.4,1.2-3.3,4.9-3.3,7.9c0,4.2,4.4,6.9,6.7,3.8"
  })), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 584.8,
    y1: 212.8,
    x2: 586.4,
    y2: 219.8
  })), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M586.5,230.6l-3.1,14.5c0,0,5,11.5,19.2,9.5c15.6-2.2,14.9-8.5,14.9-8.5l0.8-14.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M584,242.3l2.5-11.7l28.3,0.1l-2.7,3.9c-1.3,1.8-0.3,3.4-1.5,4.2c-5.7,3.7-7.5,6.2-14,7.3 C592.7,246.8,587.1,245.7,584,242.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M593.4,198.6c-0.3,0.4-11.2,21.7-10.7,30.6c0.7,11.2,7.3,14,14,14.6c6.8,0.6,14.1-2.7,21.1-8 c4.8-3.7,14-14.6,13-21.7c-0.9-7.1-5.3-17.5-14.2-19.3C607.8,192.9,597.4,193.8,593.4,198.6z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M593.7,221.9c-1.1,1.5-3.1,4.7-1.7,6.6c0.9,1.2,2.5,0.7,3.7,0.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M609.5,225.5c-0.2-1.2-0.7-2.3-1.4-3.2c-0.3-0.4-0.6-0.7-1-0.9c-0.8-0.5-1.9-0.6-2.9-0.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M592.6,216.5c-0.2-0.9-0.7-1.7-1.5-2.2c-0.8-0.5-1.8-0.6-2.7-0.4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M604,227.1c0,0.9,0.7,1.6,1.5,1.6c0.9,0,1.6-0.7,1.6-1.5c0-0.9-0.7-1.6-1.5-1.6C604.7,225.5,604,226.2,604,227.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M588,220.1c0,0.9,0.7,1.6,1.5,1.6c0.9,0,1.6-0.7,1.6-1.5c0-0.9-0.7-1.6-1.5-1.6C588.7,218.5,588,219.2,588,220.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M589.8,232.2l6.8,0.6c0,0-0.3,4.5-4,4.4C589.6,237.1,589.8,232.2,589.8,232.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M598.4,233.8c-0.2,2,1.3,3.7,3.3,3.9c2,0.2,3.7-1.3,3.9-3.3c0.2-2-1.3-3.7-3.3-3.9 C600.4,230.3,598.6,231.8,598.4,233.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M583,226.6c-0.2,1.8,1.1,3.3,2.9,3.5c1.8,0.2,3.3-1.1,3.5-2.9c0.2-1.8-1.1-3.3-2.9-3.5 C584.7,223.5,583.2,224.8,583,226.6z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M618.3,233.8c0.3,0.4,0.7,0.9,1.2,0.9c0.8,0,2.4-1.1,3-1.6c0.9-0.7,1.6-1.6,2.3-2.6 c2.8-3.9,6.6-8.9,6.2-14c-0.2-2-1.1-3.8-1.7-5.6c-0.6-1.9-1-3.8-1.9-5.6c-2-3.9-6.1-6.4-10.3-7.4s-8.7-0.8-13-0.3 c-4.8,0.5-9.7,1.3-13.8,3.8c-2.4,1.5-4.5,3.8-4.5,6.6c0,2,5.7,1.2,7,1.1c0.1,0-0.7,1.9-0.8,2.1c-0.3,0.9,0.2,1.9,0.8,2.5 c0.8,0.7,1.9,0.9,3,1c1.1,0.1,2.2,0,3.2,0.1c-0.5,0.7-1.4,1.1-1.5,1.9c0,0.5,0.3,1,0.8,1.3c0.5,0.3,1,0.3,1.5,0.4 c2.8,0.3,5.7,0.3,8.5-0.1c-0.7,0.7-0.4,1.9,0.3,2.6s1.7,0.8,2.7,0.8c1,0,2.8-0.3,2.8-0.3S614.8,229.3,618.3,233.8z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st37",
    d: "M616.4,192.7c-18.3-6.3-25.8,9-25.8,9s0,6.7,9.7,12.9c18.6,11.9,29.1,10.2,29.1,10.2 S640.7,201.1,616.4,192.7z M606.2,212.4c-5.8-1.4-8.9-5.5-8.9-5.5s2-4.3,6.1-3.5C608.3,204.4,609.2,209.1,606.2,212.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M614,229.2c1.1-2.3,4.3-3.7,6.2-2.9c3.1,1.4,3.3,5.9,1.7,8.7c-1,1.7-2.9,3.3-4.7,4c-2,0.8-4.1,0-5-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M620.3,229.3c-2.1,1.4-4.2,2.8-6.3,4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M617.9,238.9c0,0-1.6,0.8-3.1,0.4c-1.5-0.4-2.1-1.4-2.1-1.4"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M592.6,198.4c0,0,2.3,7.6,8.7,12c12.3,8.5,29.1,10.5,29.1,10.5"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M692.7,194.6c2.4,9.8,3.5,20,3.1,30.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M695.8,184.8c3.4,6,5.8,12.6,7,19.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M635.2,350.8c-3.8,15.4-7.8,30.8-12,46.2"
  }), /*#__PURE__*/React.createElement("line", {
    className: "st3",
    x1: 642.2,
    y1: 347.1,
    x2: 635.8,
    y2: 371.6
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFundoDeAcolhimento);
export default __webpack_public_path__ + "static/media/fundo-de-acolhimento.11aef141694cb44f04aedb0ba6a52867.svg";
export { ForwardRef as ReactComponent };